var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _g, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgcontactService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 811,
    height: 811,
    viewBox: "0 0 811 811",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M811 620.253H0V620.658H811V620.253Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M729.738 646.351H676.017V646.756H729.738V646.351Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M537.239 650.763H523.144V651.168H537.239V650.763Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M674.395 631.299H643.269V631.704H674.395V631.299Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.144 634.023H85.0901V634.429H155.144V634.023Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.864 634.023H169.596V634.429H179.864V634.023Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M365.193 640.868H213.244V641.274H365.193V640.868Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M384.414 547.912H71.222C68.7685 547.907 66.4169 546.93 64.6836 545.193C62.9502 543.457 61.9766 541.103 61.9766 538.65V98.3905C61.998 95.951 62.981 93.6185 64.712 91.8996C66.4431 90.1807 68.7825 89.2141 71.222 89.21H384.414C386.87 89.21 389.226 90.1857 390.963 91.9226C392.7 93.6595 393.676 96.0152 393.676 98.4716V538.65C393.676 541.106 392.7 543.462 390.963 545.199C389.226 546.936 386.87 547.912 384.414 547.912ZM71.222 89.5344C68.876 89.5387 66.6276 90.4736 64.9703 92.134C63.3129 93.7944 62.3821 96.0445 62.3821 98.3905V538.65C62.3821 540.996 63.3129 543.246 64.9703 544.906C66.6276 546.567 68.876 547.502 71.222 547.506H384.414C386.762 547.502 389.012 546.567 390.672 544.907C392.331 543.247 393.266 540.997 393.27 538.65V98.3905C393.266 96.043 392.331 93.7929 390.672 92.133C389.012 90.4731 386.762 89.5386 384.414 89.5344H71.222Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M735.269 547.912H422.061C419.606 547.907 417.252 546.93 415.516 545.194C413.78 543.458 412.803 541.105 412.799 538.65V98.3905C412.825 95.9496 413.811 93.6171 415.545 91.8986C417.279 90.1801 419.62 89.2141 422.061 89.21H735.269C737.706 89.2184 740.041 90.1868 741.768 91.9053C743.496 93.6238 744.477 95.9538 744.498 98.3905V538.65C744.498 541.101 743.527 543.451 741.797 545.187C740.067 546.923 737.72 547.903 735.269 547.912ZM422.061 89.5344C419.713 89.5386 417.463 90.4731 415.803 92.133C414.143 93.7929 413.209 96.043 413.205 98.3905V538.65C413.209 540.997 414.143 543.247 415.803 544.907C417.463 546.567 419.713 547.502 422.061 547.506H735.269C737.616 547.502 739.866 546.567 741.526 544.907C743.186 543.247 744.121 540.997 744.125 538.65V98.3905C744.121 96.043 743.186 93.7929 741.526 92.133C739.866 90.4731 737.616 89.5386 735.269 89.5344H422.061Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M722.471 190.066H329.493V568.868H722.471V190.066Z",
    fill: "#E0E0E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M722.471 196.943H335.803V562.25H722.471V196.943Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M338.657 473.786V363.896H350.06V349.379L375.752 337.376V322.519H380.035V363.896H384.317V473.786H390.026V416.692H402.872V386.734H407.154V473.786H417.13V440.957H424.267V432.393H439.967V402.434H448.532V382.451H458.523V352.477H462.805V382.451H472.797V402.434H481.345V432.393H497.046V440.957H504.182V473.786H512.747V432.393H528.448V341.074H532.73V331.083H566.97V341.074H574.107V406.717H602.654V413.837H612.629V418.119H602.654V443.812H632.612V358.186H638.322V341.074H652.595V275.432H656.878V341.074H666.869V358.186H722.471V562.25H335.803V473.786H338.657Z",
    fill: "#E6E6E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M692.756 362.663H688.717V366.702H692.756V362.663Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M692.756 369.443H688.717V373.482H692.756V369.443Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M692.756 396.563H688.717V400.602H692.756V396.563Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M692.756 403.326H688.717V407.365H692.756V403.326Z",
    fill: "#F0F0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M692.756 410.106H688.717V414.145H692.756V410.106Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M692.756 430.446H688.717V434.485H692.756V430.446Z",
    fill: "#F0F0F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M692.756 437.226H688.717V441.265H692.756V437.226Z",
    fill: "#F0F0F0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M686.333 389.783H682.294V393.822H686.333V389.783Z",
    fill: "#F0F0F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M686.333 396.563H682.294V400.602H686.333V396.563Z",
    fill: "#F0F0F0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M686.333 403.326H682.294V407.365H686.333V403.326Z",
    fill: "#F0F0F0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M686.333 410.106H682.294V414.145H686.333V410.106Z",
    fill: "#F0F0F0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M686.333 416.886H682.294V420.925H686.333V416.886Z",
    fill: "#F0F0F0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M686.333 430.446H682.294V434.485H686.333V430.446Z",
    fill: "#F0F0F0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M686.333 437.226H682.294V441.265H686.333V437.226Z",
    fill: "#F0F0F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M679.91 362.663H675.871V366.702H679.91V362.663Z",
    fill: "#F0F0F0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M679.91 369.443H675.871V373.482H679.91V369.443Z",
    fill: "#F0F0F0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M679.91 376.223H675.871V380.262H679.91V376.223Z",
    fill: "#F0F0F0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M679.91 383.003H675.871V387.042H679.91V383.003Z",
    fill: "#F0F0F0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M679.91 389.783H675.871V393.822H679.91V389.783Z",
    fill: "#F0F0F0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M679.91 396.563H675.871V400.602H679.91V396.563Z",
    fill: "#F0F0F0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M679.91 403.326H675.871V407.365H679.91V403.326Z",
    fill: "#F0F0F0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M679.91 410.106H675.871V414.145H679.91V410.106Z",
    fill: "#F0F0F0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M679.91 416.886H675.871V420.925H679.91V416.886Z",
    fill: "#F0F0F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M679.91 423.667H675.871V427.705H679.91V423.667Z",
    fill: "#F0F0F0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M679.91 437.226H675.871V441.265H679.91V437.226Z",
    fill: "#F0F0F0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M673.487 362.663H669.448V366.702H673.487V362.663Z",
    fill: "#F0F0F0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M673.487 369.443H669.448V373.482H673.487V369.443Z",
    fill: "#F0F0F0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M673.487 376.223H669.448V380.262H673.487V376.223Z",
    fill: "#F0F0F0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M673.487 383.003H669.448V387.042H673.487V383.003Z",
    fill: "#F0F0F0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M673.487 389.783H669.448V393.822H673.487V389.783Z",
    fill: "#F0F0F0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M673.487 396.563H669.448V400.602H673.487V396.563Z",
    fill: "#F0F0F0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M673.487 403.326H669.448V407.365H673.487V403.326Z",
    fill: "#F0F0F0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M673.487 464.346H669.448V468.385H673.487V464.346Z",
    fill: "#F0F0F0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 362.663H663.025V366.702H667.064V362.663Z",
    fill: "#F0F0F0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 369.443H663.025V373.482H667.064V369.443Z",
    fill: "#F0F0F0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 376.223H663.025V380.262H667.064V376.223Z",
    fill: "#F0F0F0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 383.003H663.025V387.042H667.064V383.003Z",
    fill: "#F0F0F0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 389.783H663.025V393.822H667.064V389.783Z",
    fill: "#F0F0F0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 396.563H663.025V400.602H667.064V396.563Z",
    fill: "#F0F0F0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 403.326H663.025V407.365H667.064V403.326Z",
    fill: "#F0F0F0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 410.106H663.025V414.145H667.064V410.106Z",
    fill: "#F0F0F0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 450.786H663.025V454.825H667.064V450.786Z",
    fill: "#F0F0F0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 457.566H663.025V461.605H667.064V457.566Z",
    fill: "#F0F0F0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 464.346H663.025V468.385H667.064V464.346Z",
    fill: "#F0F0F0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 471.11H663.025V475.149H667.064V471.11Z",
    fill: "#F0F0F0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M667.064 498.23H663.025V502.269H667.064V498.23Z",
    fill: "#F0F0F0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 362.663H656.602V366.702H660.641V362.663Z",
    fill: "#F0F0F0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 369.443H656.602V373.482H660.641V369.443Z",
    fill: "#F0F0F0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 376.223H656.602V380.262H660.641V376.223Z",
    fill: "#F0F0F0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 383.003H656.602V387.042H660.641V383.003Z",
    fill: "#F0F0F0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 389.783H656.602V393.822H660.641V389.783Z",
    fill: "#F0F0F0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 396.563H656.602V400.602H660.641V396.563Z",
    fill: "#F0F0F0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 403.326H656.602V407.365H660.641V403.326Z",
    fill: "#F0F0F0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 410.106H656.602V414.145H660.641V410.106Z",
    fill: "#F0F0F0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 416.886H656.602V420.925H660.641V416.886Z",
    fill: "#F0F0F0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 423.667H656.602V427.705H660.641V423.667Z",
    fill: "#F0F0F0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 444.006H656.602V448.045H660.641V444.006Z",
    fill: "#F0F0F0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 450.786H656.602V454.825H660.641V450.786Z",
    fill: "#F0F0F0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 457.566H656.602V461.605H660.641V457.566Z",
    fill: "#F0F0F0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 464.346H656.602V468.385H660.641V464.346Z",
    fill: "#F0F0F0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 471.11H656.602V475.149H660.641V471.11Z",
    fill: "#F0F0F0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M660.641 498.23H656.602V502.269H660.641V498.23Z",
    fill: "#F0F0F0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 362.663H650.179V366.702H654.217V362.663Z",
    fill: "#F0F0F0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 369.443H650.179V373.482H654.217V369.443Z",
    fill: "#F0F0F0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 376.223H650.179V380.262H654.217V376.223Z",
    fill: "#F0F0F0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 383.003H650.179V387.042H654.217V383.003Z",
    fill: "#F0F0F0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 389.783H650.179V393.822H654.217V389.783Z",
    fill: "#F0F0F0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 396.563H650.179V400.602H654.217V396.563Z",
    fill: "#F0F0F0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 403.326H650.179V407.365H654.217V403.326Z",
    fill: "#F0F0F0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 410.106H650.179V414.145H654.217V410.106Z",
    fill: "#F0F0F0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 416.886H650.179V420.925H654.217V416.886Z",
    fill: "#F0F0F0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 423.667H650.179V427.705H654.217V423.667Z",
    fill: "#F0F0F0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 430.446H650.179V434.485H654.217V430.446Z",
    fill: "#F0F0F0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 437.226H650.179V441.265H654.217V437.226Z",
    fill: "#F0F0F0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 444.006H650.179V448.045H654.217V444.006Z",
    fill: "#F0F0F0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 450.786H650.179V454.825H654.217V450.786Z",
    fill: "#F0F0F0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 457.566H650.179V461.605H654.217V457.566Z",
    fill: "#F0F0F0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 464.346H650.179V468.385H654.217V464.346Z",
    fill: "#F0F0F0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 471.11H650.179V475.149H654.217V471.11Z",
    fill: "#F0F0F0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M654.217 477.89H650.179V481.929H654.217V477.89Z",
    fill: "#F0F0F0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 362.663H643.756V366.702H647.794V362.663Z",
    fill: "#F0F0F0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 369.443H643.756V373.482H647.794V369.443Z",
    fill: "#F0F0F0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 376.223H643.756V380.262H647.794V376.223Z",
    fill: "#F0F0F0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 383.003H643.756V387.042H647.794V383.003Z",
    fill: "#F0F0F0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 389.783H643.756V393.822H647.794V389.783Z",
    fill: "#F0F0F0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 396.563H643.756V400.602H647.794V396.563Z",
    fill: "#F0F0F0"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 403.326H643.756V407.365H647.794V403.326Z",
    fill: "#F0F0F0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 410.106H643.756V414.145H647.794V410.106Z",
    fill: "#F0F0F0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 416.886H643.756V420.925H647.794V416.886Z",
    fill: "#F0F0F0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 423.667H643.756V427.705H647.794V423.667Z",
    fill: "#F0F0F0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 444.006H643.756V448.045H647.794V444.006Z",
    fill: "#F0F0F0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 450.786H643.756V454.825H647.794V450.786Z",
    fill: "#F0F0F0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 457.566H643.756V461.605H647.794V457.566Z",
    fill: "#F0F0F0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M647.794 464.346H643.756V468.385H647.794V464.346Z",
    fill: "#F0F0F0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 362.663H637.349V366.702H641.388V362.663Z",
    fill: "#F0F0F0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 369.443H637.349V373.482H641.388V369.443Z",
    fill: "#F0F0F0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 376.223H637.349V380.262H641.388V376.223Z",
    fill: "#F0F0F0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 383.003H637.349V387.042H641.388V383.003Z",
    fill: "#F0F0F0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 389.783H637.349V393.822H641.388V389.783Z",
    fill: "#F0F0F0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 396.563H637.349V400.602H641.388V396.563Z",
    fill: "#F0F0F0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 403.326H637.349V407.365H641.388V403.326Z",
    fill: "#F0F0F0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 410.106H637.349V414.145H641.388V410.106Z",
    fill: "#F0F0F0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 416.886H637.349V420.925H641.388V416.886Z",
    fill: "#F0F0F0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 423.667H637.349V427.705H641.388V423.667Z",
    fill: "#F0F0F0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 444.006H637.349V448.045H641.388V444.006Z",
    fill: "#F0F0F0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 450.786H637.349V454.825H641.388V450.786Z",
    fill: "#F0F0F0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M641.388 457.566H637.349V461.605H641.388V457.566Z",
    fill: "#F0F0F0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M569.079 345.064H565.04V349.103H569.079V345.064Z",
    fill: "#F0F0F0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M569.079 351.844H565.04V355.883H569.079V351.844Z",
    fill: "#F0F0F0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M569.079 358.624H565.04V362.663H569.079V358.624Z",
    fill: "#F0F0F0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M569.079 365.404H565.04V369.443H569.079V365.404Z",
    fill: "#F0F0F0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M569.079 372.184H565.04V376.223H569.079V372.184Z",
    fill: "#F0F0F0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M569.079 378.964H565.04V383.003H569.079V378.964Z",
    fill: "#F0F0F0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M569.079 385.728H565.04V389.767H569.079V385.728Z",
    fill: "#F0F0F0"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M569.079 392.508H565.04V396.547H569.079V392.508Z",
    fill: "#F0F0F0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M569.079 412.848H565.04V416.886H569.079V412.848Z",
    fill: "#F0F0F0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M569.079 419.628H565.04V423.666H569.079V419.628Z",
    fill: "#F0F0F0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M562.656 345.064H558.617V349.103H562.656V345.064Z",
    fill: "#F0F0F0"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M562.656 351.844H558.617V355.883H562.656V351.844Z",
    fill: "#F0F0F0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M562.656 358.624H558.617V362.663H562.656V358.624Z",
    fill: "#F0F0F0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M562.656 365.404H558.617V369.443H562.656V365.404Z",
    fill: "#F0F0F0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M562.656 372.184H558.617V376.223H562.656V372.184Z",
    fill: "#F0F0F0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M562.656 378.964H558.617V383.003H562.656V378.964Z",
    fill: "#F0F0F0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M562.656 385.728H558.617V389.767H562.656V385.728Z",
    fill: "#F0F0F0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M562.656 392.508H558.617V396.547H562.656V392.508Z",
    fill: "#F0F0F0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M562.656 419.628H558.617V423.666H562.656V419.628Z",
    fill: "#F0F0F0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M556.232 345.064H552.194V349.103H556.232V345.064Z",
    fill: "#F0F0F0"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M556.232 351.844H552.194V355.883H556.232V351.844Z",
    fill: "#F0F0F0"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M556.232 358.624H552.194V362.663H556.232V358.624Z",
    fill: "#F0F0F0"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M556.232 365.404H552.194V369.443H556.232V365.404Z",
    fill: "#F0F0F0"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M556.232 372.184H552.194V376.223H556.232V372.184Z",
    fill: "#F0F0F0"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M556.232 378.964H552.194V383.003H556.232V378.964Z",
    fill: "#F0F0F0"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M556.232 385.728H552.194V389.767H556.232V385.728Z",
    fill: "#F0F0F0"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M556.232 392.508H552.194V396.547H556.232V392.508Z",
    fill: "#F0F0F0"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 345.064H545.771V349.103H549.809V345.064Z",
    fill: "#F0F0F0"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 351.844H545.771V355.883H549.809V351.844Z",
    fill: "#F0F0F0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 358.624H545.771V362.663H549.809V358.624Z",
    fill: "#F0F0F0"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 365.404H545.771V369.443H549.809V365.404Z",
    fill: "#F0F0F0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 372.184H545.771V376.223H549.809V372.184Z",
    fill: "#F0F0F0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 378.964H545.771V383.003H549.809V378.964Z",
    fill: "#F0F0F0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 392.508H545.771V396.547H549.809V392.508Z",
    fill: "#F0F0F0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 399.288H545.771V403.326H549.809V399.288Z",
    fill: "#F0F0F0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 419.628H545.771V423.666H549.809V419.628Z",
    fill: "#F0F0F0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 426.407H545.771V430.446H549.809V426.407Z",
    fill: "#F0F0F0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 433.188H545.771V437.226H549.809V433.188Z",
    fill: "#F0F0F0"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 439.968H545.771V444.006H549.809V439.968Z",
    fill: "#F0F0F0"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 446.747H545.771V450.786H549.809V446.747Z",
    fill: "#F0F0F0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 453.511H545.771V457.55H549.809V453.511Z",
    fill: "#F0F0F0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M549.809 460.291H545.771V464.33H549.809V460.291Z",
    fill: "#F0F0F0"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 345.064H539.347V349.103H543.386V345.064Z",
    fill: "#F0F0F0"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 351.844H539.347V355.883H543.386V351.844Z",
    fill: "#F0F0F0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 358.624H539.347V362.663H543.386V358.624Z",
    fill: "#F0F0F0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 365.404H539.347V369.443H543.386V365.404Z",
    fill: "#F0F0F0"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 372.184H539.347V376.223H543.386V372.184Z",
    fill: "#F0F0F0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 378.964H539.347V383.003H543.386V378.964Z",
    fill: "#F0F0F0"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 399.288H539.347V403.326H543.386V399.288Z",
    fill: "#F0F0F0"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 406.068H539.347V410.106H543.386V406.068Z",
    fill: "#F0F0F0"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 412.848H539.347V416.886H543.386V412.848Z",
    fill: "#F0F0F0"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 419.628H539.347V423.666H543.386V419.628Z",
    fill: "#F0F0F0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 426.407H539.347V430.446H543.386V426.407Z",
    fill: "#F0F0F0"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 433.188H539.347V437.226H543.386V433.188Z",
    fill: "#F0F0F0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 439.968H539.347V444.006H543.386V439.968Z",
    fill: "#F0F0F0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 446.747H539.347V450.786H543.386V446.747Z",
    fill: "#F0F0F0"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 453.511H539.347V457.55H543.386V453.511Z",
    fill: "#F0F0F0"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 460.291H539.347V464.33H543.386V460.291Z",
    fill: "#F0F0F0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 467.071H539.347V471.11H543.386V467.071Z",
    fill: "#F0F0F0"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M543.386 480.631H539.347V484.67H543.386V480.631Z",
    fill: "#F0F0F0"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 345.064H532.924V349.103H536.963V345.064Z",
    fill: "#F0F0F0"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 351.844H532.924V355.883H536.963V351.844Z",
    fill: "#F0F0F0"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 358.624H532.924V362.663H536.963V358.624Z",
    fill: "#F0F0F0"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 365.404H532.924V369.443H536.963V365.404Z",
    fill: "#F0F0F0"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 372.184H532.924V376.223H536.963V372.184Z",
    fill: "#F0F0F0"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 378.964H532.924V383.003H536.963V378.964Z",
    fill: "#F0F0F0"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 399.288H532.924V403.326H536.963V399.288Z",
    fill: "#F0F0F0"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 406.068H532.924V410.106H536.963V406.068Z",
    fill: "#F0F0F0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 412.848H532.924V416.886H536.963V412.848Z",
    fill: "#F0F0F0"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 419.628H532.924V423.666H536.963V419.628Z",
    fill: "#F0F0F0"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 439.968H532.924V444.006H536.963V439.968Z",
    fill: "#F0F0F0"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 446.747H532.924V450.786H536.963V446.747Z",
    fill: "#F0F0F0"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 453.511H532.924V457.55H536.963V453.511Z",
    fill: "#F0F0F0"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 460.291H532.924V464.33H536.963V460.291Z",
    fill: "#F0F0F0"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 467.071H532.924V471.11H536.963V467.071Z",
    fill: "#F0F0F0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 480.631H532.924V484.67H536.963V480.631Z",
    fill: "#F0F0F0"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M536.963 487.411H532.924V491.45H536.963V487.411Z",
    fill: "#F0F0F0"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M478.701 408.095H474.662V412.134H478.701V408.095Z",
    fill: "#F0F0F0"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M478.701 414.875H474.662V418.914H478.701V414.875Z",
    fill: "#F0F0F0"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M478.701 421.655H474.662V425.694H478.701V421.655Z",
    fill: "#F0F0F0"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M478.701 428.419H474.662V432.458H478.701V428.419Z",
    fill: "#F0F0F0"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M478.701 435.199H474.662V439.237H478.701V435.199Z",
    fill: "#F0F0F0"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M478.701 441.979H474.662V446.018H478.701V441.979Z",
    fill: "#F0F0F0"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M478.701 448.759H474.662V452.798H478.701V448.759Z",
    fill: "#F0F0F0"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M478.701 469.099H474.662V473.137H478.701V469.099Z",
    fill: "#F0F0F0"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M478.701 475.879H474.662V479.917H478.701V475.879Z",
    fill: "#F0F0F0"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M478.701 482.658H474.662V486.697H478.701V482.658Z",
    fill: "#F0F0F0"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M472.278 408.095H468.239V412.134H472.278V408.095Z",
    fill: "#F0F0F0"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M472.278 414.875H468.239V418.914H472.278V414.875Z",
    fill: "#F0F0F0"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M472.278 421.655H468.239V425.694H472.278V421.655Z",
    fill: "#F0F0F0"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M472.278 428.419H468.239V432.458H472.278V428.419Z",
    fill: "#F0F0F0"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M472.278 435.199H468.239V439.237H472.278V435.199Z",
    fill: "#F0F0F0"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M472.278 441.979H468.239V446.018H472.278V441.979Z",
    fill: "#F0F0F0"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M472.278 448.759H468.239V452.798H472.278V448.759Z",
    fill: "#F0F0F0"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M465.855 408.095H461.816V412.134H465.855V408.095Z",
    fill: "#F0F0F0"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M465.855 414.875H461.816V418.914H465.855V414.875Z",
    fill: "#F0F0F0"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M465.855 421.655H461.816V425.694H465.855V421.655Z",
    fill: "#F0F0F0"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M465.855 428.419H461.816V432.458H465.855V428.419Z",
    fill: "#F0F0F0"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M465.855 435.199H461.816V439.237H465.855V435.199Z",
    fill: "#F0F0F0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M465.855 441.979H461.816V446.018H465.855V441.979Z",
    fill: "#F0F0F0"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M465.855 448.759H461.816V452.798H465.855V448.759Z",
    fill: "#F0F0F0"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M459.431 408.095H455.393V412.134H459.431V408.095Z",
    fill: "#F0F0F0"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M459.431 414.875H455.393V418.914H459.431V414.875Z",
    fill: "#F0F0F0"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M459.431 421.655H455.393V425.694H459.431V421.655Z",
    fill: "#F0F0F0"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M459.431 428.419H455.393V432.458H459.431V428.419Z",
    fill: "#F0F0F0"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M459.431 435.199H455.393V439.237H459.431V435.199Z",
    fill: "#F0F0F0"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M459.431 441.979H455.393V446.018H459.431V441.979Z",
    fill: "#F0F0F0"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M459.431 448.759H455.393V452.798H459.431V448.759Z",
    fill: "#F0F0F0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M459.431 455.539H455.393V459.577H459.431V455.539Z",
    fill: "#F0F0F0"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M459.431 462.319H455.393V466.357H459.431V462.319Z",
    fill: "#F0F0F0"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M459.431 469.099H455.393V473.137H459.431V469.099Z",
    fill: "#F0F0F0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M459.431 475.879H455.393V479.917H459.431V475.879Z",
    fill: "#F0F0F0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 408.095H448.97V412.134H453.008V408.095Z",
    fill: "#F0F0F0"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 414.875H448.97V418.914H453.008V414.875Z",
    fill: "#F0F0F0"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 421.655H448.97V425.694H453.008V421.655Z",
    fill: "#F0F0F0"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 428.419H448.97V432.458H453.008V428.419Z",
    fill: "#F0F0F0"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 435.199H448.97V439.237H453.008V435.199Z",
    fill: "#F0F0F0"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 441.979H448.97V446.018H453.008V441.979Z",
    fill: "#F0F0F0"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 448.759H448.97V452.798H453.008V448.759Z",
    fill: "#F0F0F0"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 455.539H448.97V459.577H453.008V455.539Z",
    fill: "#F0F0F0"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 462.319H448.97V466.357H453.008V462.319Z",
    fill: "#F0F0F0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 469.099H448.97V473.137H453.008V469.099Z",
    fill: "#F0F0F0"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 475.879H448.97V479.917H453.008V475.879Z",
    fill: "#F0F0F0"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 482.658H448.97V486.697H453.008V482.658Z",
    fill: "#F0F0F0"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 502.982H448.97V507.021H453.008V502.982Z",
    fill: "#F0F0F0"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M453.008 509.762H448.97V513.801H453.008V509.762Z",
    fill: "#F0F0F0"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 408.095H442.547V412.134H446.585V408.095Z",
    fill: "#F0F0F0"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 414.875H442.547V418.914H446.585V414.875Z",
    fill: "#F0F0F0"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 421.655H442.547V425.694H446.585V421.655Z",
    fill: "#F0F0F0"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 441.979H442.547V446.018H446.585V441.979Z",
    fill: "#F0F0F0"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 448.759H442.547V452.798H446.585V448.759Z",
    fill: "#F0F0F0"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 455.539H442.547V459.577H446.585V455.539Z",
    fill: "#F0F0F0"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 462.319H442.547V466.357H446.585V462.319Z",
    fill: "#F0F0F0"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 469.099H442.547V473.137H446.585V469.099Z",
    fill: "#F0F0F0"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 475.879H442.547V479.917H446.585V475.879Z",
    fill: "#F0F0F0"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 482.658H442.547V486.697H446.585V482.658Z",
    fill: "#F0F0F0"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 502.982H442.547V507.021H446.585V502.982Z",
    fill: "#F0F0F0"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 509.762H442.547V513.801H446.585V509.762Z",
    fill: "#F0F0F0"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M446.585 516.542H442.547V520.581H446.585V516.542Z",
    fill: "#F0F0F0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 367.416H375.25V371.454H379.289V367.416Z",
    fill: "#F0F0F0"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 374.195H375.25V378.234H379.289V374.195Z",
    fill: "#F0F0F0"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 380.975H375.25V385.014H379.289V380.975Z",
    fill: "#F0F0F0"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 387.755H375.25V391.794H379.289V387.755Z",
    fill: "#F0F0F0"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 394.535H375.25V398.574H379.289V394.535Z",
    fill: "#F0F0F0"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 401.315H375.25V405.354H379.289V401.315Z",
    fill: "#F0F0F0"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 408.095H375.25V412.134H379.289V408.095Z",
    fill: "#F0F0F0"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 414.875H375.25V418.914H379.289V414.875Z",
    fill: "#F0F0F0"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 421.655H375.25V425.694H379.289V421.655Z",
    fill: "#F0F0F0"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 428.419H375.25V432.458H379.289V428.419Z",
    fill: "#F0F0F0"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 435.199H375.25V439.237H379.289V435.199Z",
    fill: "#F0F0F0"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 441.979H375.25V446.018H379.289V441.979Z",
    fill: "#F0F0F0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 448.759H375.25V452.798H379.289V448.759Z",
    fill: "#F0F0F0"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 455.539H375.25V459.577H379.289V455.539Z",
    fill: "#F0F0F0"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 462.319H375.25V466.357H379.289V462.319Z",
    fill: "#F0F0F0"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 469.099H375.25V473.137H379.289V469.099Z",
    fill: "#F0F0F0"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 475.879H375.25V479.917H379.289V475.879Z",
    fill: "#F0F0F0"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 482.658H375.25V486.697H379.289V482.658Z",
    fill: "#F0F0F0"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 489.438H375.25V493.477H379.289V489.438Z",
    fill: "#F0F0F0"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 496.202H375.25V500.241H379.289V496.202Z",
    fill: "#F0F0F0"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 502.982H375.25V507.021H379.289V502.982Z",
    fill: "#F0F0F0"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 509.762H375.25V513.801H379.289V509.762Z",
    fill: "#F0F0F0"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M379.289 516.542H375.25V520.581H379.289V516.542Z",
    fill: "#F0F0F0"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 367.416H368.827V371.454H372.865V367.416Z",
    fill: "#F0F0F0"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 374.195H368.827V378.234H372.865V374.195Z",
    fill: "#F0F0F0"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 380.975H368.827V385.014H372.865V380.975Z",
    fill: "#F0F0F0"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 387.755H368.827V391.794H372.865V387.755Z",
    fill: "#F0F0F0"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 394.535H368.827V398.574H372.865V394.535Z",
    fill: "#F0F0F0"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 401.315H368.827V405.354H372.865V401.315Z",
    fill: "#F0F0F0"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 408.095H368.827V412.134H372.865V408.095Z",
    fill: "#F0F0F0"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 414.875H368.827V418.914H372.865V414.875Z",
    fill: "#F0F0F0"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 421.655H368.827V425.694H372.865V421.655Z",
    fill: "#F0F0F0"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 428.419H368.827V432.458H372.865V428.419Z",
    fill: "#F0F0F0"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 435.199H368.827V439.237H372.865V435.199Z",
    fill: "#F0F0F0"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 441.979H368.827V446.018H372.865V441.979Z",
    fill: "#F0F0F0"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 448.759H368.827V452.798H372.865V448.759Z",
    fill: "#F0F0F0"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 455.539H368.827V459.577H372.865V455.539Z",
    fill: "#F0F0F0"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 462.319H368.827V466.357H372.865V462.319Z",
    fill: "#F0F0F0"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 469.099H368.827V473.137H372.865V469.099Z",
    fill: "#F0F0F0"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 475.879H368.827V479.917H372.865V475.879Z",
    fill: "#F0F0F0"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 482.658H368.827V486.697H372.865V482.658Z",
    fill: "#F0F0F0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M372.865 489.438H368.827V493.477H372.865V489.438Z",
    fill: "#F0F0F0"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 367.416H362.403V371.454H366.442V367.416Z",
    fill: "#F0F0F0"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 374.195H362.403V378.234H366.442V374.195Z",
    fill: "#F0F0F0"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 380.975H362.403V385.014H366.442V380.975Z",
    fill: "#F0F0F0"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 387.755H362.403V391.794H366.442V387.755Z",
    fill: "#F0F0F0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 394.535H362.403V398.574H366.442V394.535Z",
    fill: "#F0F0F0"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 401.315H362.403V405.354H366.442V401.315Z",
    fill: "#F0F0F0"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 408.095H362.403V412.134H366.442V408.095Z",
    fill: "#F0F0F0"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 414.875H362.403V418.914H366.442V414.875Z",
    fill: "#F0F0F0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 421.655H362.403V425.694H366.442V421.655Z",
    fill: "#F0F0F0"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 428.419H362.403V432.458H366.442V428.419Z",
    fill: "#F0F0F0"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 435.199H362.403V439.237H366.442V435.199Z",
    fill: "#F0F0F0"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 441.979H362.403V446.018H366.442V441.979Z",
    fill: "#F0F0F0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 448.759H362.403V452.798H366.442V448.759Z",
    fill: "#F0F0F0"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 455.539H362.403V459.577H366.442V455.539Z",
    fill: "#F0F0F0"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 462.319H362.403V466.357H366.442V462.319Z",
    fill: "#F0F0F0"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 469.099H362.403V473.137H366.442V469.099Z",
    fill: "#F0F0F0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 475.879H362.403V479.917H366.442V475.879Z",
    fill: "#F0F0F0"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 482.658H362.403V486.697H366.442V482.658Z",
    fill: "#F0F0F0"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M366.442 489.438H362.403V493.477H366.442V489.438Z",
    fill: "#F0F0F0"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 367.416H355.98V371.454H360.019V367.416Z",
    fill: "#F0F0F0"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 374.195H355.98V378.234H360.019V374.195Z",
    fill: "#F0F0F0"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 380.975H355.98V385.014H360.019V380.975Z",
    fill: "#F0F0F0"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 387.755H355.98V391.794H360.019V387.755Z",
    fill: "#F0F0F0"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 394.535H355.98V398.574H360.019V394.535Z",
    fill: "#F0F0F0"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 401.315H355.98V405.354H360.019V401.315Z",
    fill: "#F0F0F0"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 408.095H355.98V412.134H360.019V408.095Z",
    fill: "#F0F0F0"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 414.875H355.98V418.914H360.019V414.875Z",
    fill: "#F0F0F0"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 421.655H355.98V425.694H360.019V421.655Z",
    fill: "#F0F0F0"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 428.419H355.98V432.458H360.019V428.419Z",
    fill: "#F0F0F0"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 435.199H355.98V439.237H360.019V435.199Z",
    fill: "#F0F0F0"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 441.979H355.98V446.018H360.019V441.979Z",
    fill: "#F0F0F0"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 448.759H355.98V452.798H360.019V448.759Z",
    fill: "#F0F0F0"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 455.539H355.98V459.577H360.019V455.539Z",
    fill: "#F0F0F0"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M360.019 462.319H355.98V466.357H360.019V462.319Z",
    fill: "#F0F0F0"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 367.416H349.557V371.454H353.596V367.416Z",
    fill: "#F0F0F0"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 374.195H349.557V378.234H353.596V374.195Z",
    fill: "#F0F0F0"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 380.975H349.557V385.014H353.596V380.975Z",
    fill: "#F0F0F0"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 387.755H349.557V391.794H353.596V387.755Z",
    fill: "#F0F0F0"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 394.535H349.557V398.574H353.596V394.535Z",
    fill: "#F0F0F0"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 401.315H349.557V405.354H353.596V401.315Z",
    fill: "#F0F0F0"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 408.095H349.557V412.134H353.596V408.095Z",
    fill: "#F0F0F0"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 414.875H349.557V418.914H353.596V414.875Z",
    fill: "#F0F0F0"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 421.655H349.557V425.694H353.596V421.655Z",
    fill: "#F0F0F0"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 428.419H349.557V432.458H353.596V428.419Z",
    fill: "#F0F0F0"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 435.199H349.557V439.237H353.596V435.199Z",
    fill: "#F0F0F0"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 441.979H349.557V446.018H353.596V441.979Z",
    fill: "#F0F0F0"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M353.596 448.759H349.557V452.798H353.596V448.759Z",
    fill: "#F0F0F0"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M347.173 367.416H343.134V371.454H347.173V367.416Z",
    fill: "#F0F0F0"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M347.173 374.195H343.134V378.234H347.173V374.195Z",
    fill: "#F0F0F0"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M347.173 380.975H343.134V385.014H347.173V380.975Z",
    fill: "#F0F0F0"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M347.173 387.755H343.134V391.794H347.173V387.755Z",
    fill: "#F0F0F0"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M347.173 394.535H343.134V398.574H347.173V394.535Z",
    fill: "#F0F0F0"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M347.173 401.315H343.134V405.354H347.173V401.315Z",
    fill: "#F0F0F0"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M347.173 408.095H343.134V412.134H347.173V408.095Z",
    fill: "#F0F0F0"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M347.173 414.875H343.134V418.914H347.173V414.875Z",
    fill: "#F0F0F0"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M347.173 421.655H343.134V425.694H347.173V421.655Z",
    fill: "#F0F0F0"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M347.173 428.419H343.134V432.458H347.173V428.419Z",
    fill: "#F0F0F0"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M347.173 435.199H343.134V439.237H347.173V435.199Z",
    fill: "#F0F0F0"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M347.173 441.979H343.134V446.018H347.173V441.979Z",
    fill: "#F0F0F0"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 365.404H717.962V369.443H722.001V365.404Z",
    fill: "#F0F0F0"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 372.184H717.962V376.223H722.001V372.184Z",
    fill: "#F0F0F0"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 378.964H717.962V383.003H722.001V378.964Z",
    fill: "#F0F0F0"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 385.728H717.962V389.767H722.001V385.728Z",
    fill: "#F0F0F0"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 392.508H717.962V396.547H722.001V392.508Z",
    fill: "#F0F0F0"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 399.288H717.962V403.326H722.001V399.288Z",
    fill: "#F0F0F0"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 406.068H717.962V410.106H722.001V406.068Z",
    fill: "#F0F0F0"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 412.848H717.962V416.886H722.001V412.848Z",
    fill: "#F0F0F0"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 419.628H717.962V423.666H722.001V419.628Z",
    fill: "#F0F0F0"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 426.407H717.962V430.446H722.001V426.407Z",
    fill: "#F0F0F0"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 433.188H717.962V437.226H722.001V433.188Z",
    fill: "#F0F0F0"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 439.968H717.962V444.006H722.001V439.968Z",
    fill: "#F0F0F0"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 446.747H717.962V450.786H722.001V446.747Z",
    fill: "#F0F0F0"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 453.511H717.962V457.55H722.001V453.511Z",
    fill: "#F0F0F0"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 460.291H717.962V464.33H722.001V460.291Z",
    fill: "#F0F0F0"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 467.071H717.962V471.11H722.001V467.071Z",
    fill: "#F0F0F0"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 473.851H717.962V477.89H722.001V473.851Z",
    fill: "#F0F0F0"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 487.411H717.962V491.45H722.001V487.411Z",
    fill: "#F0F0F0"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 494.191H717.962V498.23H722.001V494.191Z",
    fill: "#F0F0F0"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 500.971H717.962V505.01H722.001V500.971Z",
    fill: "#F0F0F0"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 507.751H717.962V511.789H722.001V507.751Z",
    fill: "#F0F0F0"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M722.001 514.515H717.962V518.553H722.001V514.515Z",
    fill: "#F0F0F0"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 365.404H711.539V369.443H715.578V365.404Z",
    fill: "#F0F0F0"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 372.184H711.539V376.223H715.578V372.184Z",
    fill: "#F0F0F0"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 378.964H711.539V383.003H715.578V378.964Z",
    fill: "#F0F0F0"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 385.728H711.539V389.767H715.578V385.728Z",
    fill: "#F0F0F0"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 392.508H711.539V396.547H715.578V392.508Z",
    fill: "#F0F0F0"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 399.288H711.539V403.326H715.578V399.288Z",
    fill: "#F0F0F0"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 406.068H711.539V410.106H715.578V406.068Z",
    fill: "#F0F0F0"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 412.848H711.539V416.886H715.578V412.848Z",
    fill: "#F0F0F0"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 419.628H711.539V423.666H715.578V419.628Z",
    fill: "#F0F0F0"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 426.407H711.539V430.446H715.578V426.407Z",
    fill: "#F0F0F0"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 433.188H711.539V437.226H715.578V433.188Z",
    fill: "#F0F0F0"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 439.968H711.539V444.006H715.578V439.968Z",
    fill: "#F0F0F0"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 446.747H711.539V450.786H715.578V446.747Z",
    fill: "#F0F0F0"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 453.511H711.539V457.55H715.578V453.511Z",
    fill: "#F0F0F0"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 460.291H711.539V464.33H715.578V460.291Z",
    fill: "#F0F0F0"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 467.071H711.539V471.11H715.578V467.071Z",
    fill: "#F0F0F0"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 507.751H711.539V511.789H715.578V507.751Z",
    fill: "#F0F0F0"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M715.578 514.515H711.539V518.553H715.578V514.515Z",
    fill: "#F0F0F0"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 365.404H705.132V369.443H709.171V365.404Z",
    fill: "#F0F0F0"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 372.184H705.132V376.223H709.171V372.184Z",
    fill: "#F0F0F0"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 378.964H705.132V383.003H709.171V378.964Z",
    fill: "#F0F0F0"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 385.728H705.132V389.767H709.171V385.728Z",
    fill: "#F0F0F0"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 392.508H705.132V396.547H709.171V392.508Z",
    fill: "#F0F0F0"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 399.288H705.132V403.326H709.171V399.288Z",
    fill: "#F0F0F0"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 406.068H705.132V410.106H709.171V406.068Z",
    fill: "#F0F0F0"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 412.848H705.132V416.886H709.171V412.848Z",
    fill: "#F0F0F0"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 419.628H705.132V423.666H709.171V419.628Z",
    fill: "#F0F0F0"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 426.407H705.132V430.446H709.171V426.407Z",
    fill: "#F0F0F0"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 433.188H705.132V437.226H709.171V433.188Z",
    fill: "#F0F0F0"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 439.968H705.132V444.006H709.171V439.968Z",
    fill: "#F0F0F0"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 446.747H705.132V450.786H709.171V446.747Z",
    fill: "#F0F0F0"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 453.511H705.132V457.55H709.171V453.511Z",
    fill: "#F0F0F0"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 460.291H705.132V464.33H709.171V460.291Z",
    fill: "#F0F0F0"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 467.071H705.132V471.11H709.171V467.071Z",
    fill: "#F0F0F0"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 480.631H705.132V484.67H709.171V480.631Z",
    fill: "#F0F0F0"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 487.411H705.132V491.45H709.171V487.411Z",
    fill: "#F0F0F0"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 494.191H705.132V498.23H709.171V494.191Z",
    fill: "#F0F0F0"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 500.971H705.132V505.01H709.171V500.971Z",
    fill: "#F0F0F0"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M709.171 514.515H705.132V518.553H709.171V514.515Z",
    fill: "#F0F0F0"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 412.848H593.101V416.886H597.139V412.848Z",
    fill: "#F0F0F0"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 419.628H593.101V423.666H597.139V419.628Z",
    fill: "#F0F0F0"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 426.407H593.101V430.446H597.139V426.407Z",
    fill: "#F0F0F0"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 433.188H593.101V437.226H597.139V433.188Z",
    fill: "#F0F0F0"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 439.968H593.101V444.006H597.139V439.968Z",
    fill: "#F0F0F0"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 446.747H593.101V450.786H597.139V446.747Z",
    fill: "#F0F0F0"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 453.511H593.101V457.55H597.139V453.511Z",
    fill: "#F0F0F0"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 460.291H593.101V464.33H597.139V460.291Z",
    fill: "#F0F0F0"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 467.071H593.101V471.11H597.139V467.071Z",
    fill: "#F0F0F0"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 473.851H593.101V477.89H597.139V473.851Z",
    fill: "#F0F0F0"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 480.631H593.101V484.67H597.139V480.631Z",
    fill: "#F0F0F0"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 487.411H593.101V491.45H597.139V487.411Z",
    fill: "#F0F0F0"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 494.191H593.101V498.23H597.139V494.191Z",
    fill: "#F0F0F0"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 507.751H593.101V511.789H597.139V507.751Z",
    fill: "#F0F0F0"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 514.515H593.101V518.553H597.139V514.515Z",
    fill: "#F0F0F0"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 521.295H593.101V525.333H597.139V521.295Z",
    fill: "#F0F0F0"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 528.074H593.101V532.113H597.139V528.074Z",
    fill: "#F0F0F0"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 541.634H593.101V545.673H597.139V541.634Z",
    fill: "#F0F0F0"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 548.414H593.101V552.453H597.139V548.414Z",
    fill: "#F0F0F0"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M597.139 555.194H593.101V559.233H597.139V555.194Z",
    fill: "#F0F0F0"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 412.848H586.677V416.886H590.716V412.848Z",
    fill: "#F0F0F0"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 419.628H586.677V423.666H590.716V419.628Z",
    fill: "#F0F0F0"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 426.407H586.677V430.446H590.716V426.407Z",
    fill: "#F0F0F0"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 433.188H586.677V437.226H590.716V433.188Z",
    fill: "#F0F0F0"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 439.968H586.677V444.006H590.716V439.968Z",
    fill: "#F0F0F0"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 446.747H586.677V450.786H590.716V446.747Z",
    fill: "#F0F0F0"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 453.511H586.677V457.55H590.716V453.511Z",
    fill: "#F0F0F0"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 460.291H586.677V464.33H590.716V460.291Z",
    fill: "#F0F0F0"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 467.071H586.677V471.11H590.716V467.071Z",
    fill: "#F0F0F0"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 473.851H586.677V477.89H590.716V473.851Z",
    fill: "#F0F0F0"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 480.631H586.677V484.67H590.716V480.631Z",
    fill: "#F0F0F0"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 487.411H586.677V491.45H590.716V487.411Z",
    fill: "#F0F0F0"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 494.191H586.677V498.23H590.716V494.191Z",
    fill: "#F0F0F0"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 514.515H586.677V518.553H590.716V514.515Z",
    fill: "#F0F0F0"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 521.295H586.677V525.333H590.716V521.295Z",
    fill: "#F0F0F0"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 534.854H586.677V538.893H590.716V534.854Z",
    fill: "#F0F0F0"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 541.634H586.677V545.673H590.716V541.634Z",
    fill: "#F0F0F0"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 548.414H586.677V552.453H590.716V548.414Z",
    fill: "#F0F0F0"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M590.716 555.194H586.677V559.233H590.716V555.194Z",
    fill: "#F0F0F0"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 412.848H580.254V416.886H584.293V412.848Z",
    fill: "#F0F0F0"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 419.628H580.254V423.666H584.293V419.628Z",
    fill: "#F0F0F0"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 426.407H580.254V430.446H584.293V426.407Z",
    fill: "#F0F0F0"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 433.188H580.254V437.226H584.293V433.188Z",
    fill: "#F0F0F0"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 439.968H580.254V444.006H584.293V439.968Z",
    fill: "#F0F0F0"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 446.747H580.254V450.786H584.293V446.747Z",
    fill: "#F0F0F0"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 453.511H580.254V457.55H584.293V453.511Z",
    fill: "#F0F0F0"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 460.291H580.254V464.33H584.293V460.291Z",
    fill: "#F0F0F0"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 467.071H580.254V471.11H584.293V467.071Z",
    fill: "#F0F0F0"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 473.851H580.254V477.89H584.293V473.851Z",
    fill: "#F0F0F0"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 480.631H580.254V484.67H584.293V480.631Z",
    fill: "#F0F0F0"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 487.411H580.254V491.45H584.293V487.411Z",
    fill: "#F0F0F0"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 494.191H580.254V498.23H584.293V494.191Z",
    fill: "#F0F0F0"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 500.971H580.254V505.01H584.293V500.971Z",
    fill: "#F0F0F0"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 514.515H580.254V518.553H584.293V514.515Z",
    fill: "#F0F0F0"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 528.074H580.254V532.113H584.293V528.074Z",
    fill: "#F0F0F0"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 534.854H580.254V538.893H584.293V534.854Z",
    fill: "#F0F0F0"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 541.634H580.254V545.673H584.293V541.634Z",
    fill: "#F0F0F0"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 548.414H580.254V552.453H584.293V548.414Z",
    fill: "#F0F0F0"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M584.293 555.194H580.254V559.233H584.293V555.194Z",
    fill: "#F0F0F0"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 451.5H619.263V455.539H623.302V451.5Z",
    fill: "#F0F0F0"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 458.28H619.263V462.319H623.302V458.28Z",
    fill: "#F0F0F0"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 465.06H619.263V469.099H623.302V465.06Z",
    fill: "#F0F0F0"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 471.823H619.263V475.862H623.302V471.823Z",
    fill: "#F0F0F0"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 478.604H619.263V482.642H623.302V478.604Z",
    fill: "#F0F0F0"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 485.384H619.263V489.422H623.302V485.384Z",
    fill: "#F0F0F0"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 505.723H619.263V509.762H623.302V505.723Z",
    fill: "#F0F0F0"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 512.503H619.263V516.542H623.302V512.503Z",
    fill: "#F0F0F0"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 519.283H619.263V523.322H623.302V519.283Z",
    fill: "#F0F0F0"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 526.063H619.263V530.102H623.302V526.063Z",
    fill: "#F0F0F0"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 532.843H619.263V536.882H623.302V532.843Z",
    fill: "#F0F0F0"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 539.607H619.263V543.646H623.302V539.607Z",
    fill: "#F0F0F0"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M623.302 546.387H619.263V550.426H623.302V546.387Z",
    fill: "#F0F0F0"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 451.5H612.84V455.539H616.879V451.5Z",
    fill: "#F0F0F0"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 458.28H612.84V462.319H616.879V458.28Z",
    fill: "#F0F0F0"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 465.06H612.84V469.099H616.879V465.06Z",
    fill: "#F0F0F0"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 471.823H612.84V475.862H616.879V471.823Z",
    fill: "#F0F0F0"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 478.604H612.84V482.642H616.879V478.604Z",
    fill: "#F0F0F0"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 485.384H612.84V489.422H616.879V485.384Z",
    fill: "#F0F0F0"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 505.723H612.84V509.762H616.879V505.723Z",
    fill: "#F0F0F0"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 512.503H612.84V516.542H616.879V512.503Z",
    fill: "#F0F0F0"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 519.283H612.84V523.322H616.879V519.283Z",
    fill: "#F0F0F0"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 526.063H612.84V530.102H616.879V526.063Z",
    fill: "#F0F0F0"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 532.843H612.84V536.882H616.879V532.843Z",
    fill: "#F0F0F0"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 539.607H612.84V543.646H616.879V539.607Z",
    fill: "#F0F0F0"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M616.879 553.167H612.84V557.206H616.879V553.167Z",
    fill: "#F0F0F0"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 421.655H399.499V425.694H403.537V421.655Z",
    fill: "#F0F0F0"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 428.419H399.499V432.458H403.537V428.419Z",
    fill: "#F0F0F0"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 435.199H399.499V439.237H403.537V435.199Z",
    fill: "#F0F0F0"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 441.979H399.499V446.018H403.537V441.979Z",
    fill: "#F0F0F0"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 448.759H399.499V452.798H403.537V448.759Z",
    fill: "#F0F0F0"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 455.539H399.499V459.577H403.537V455.539Z",
    fill: "#F0F0F0"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 462.319H399.499V466.357H403.537V462.319Z",
    fill: "#F0F0F0"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 469.099H399.499V473.137H403.537V469.099Z",
    fill: "#F0F0F0"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 475.879H399.499V479.917H403.537V475.879Z",
    fill: "#F0F0F0"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 482.658H399.499V486.697H403.537V482.658Z",
    fill: "#F0F0F0"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 489.438H399.499V493.477H403.537V489.438Z",
    fill: "#F0F0F0"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 502.982H399.499V507.021H403.537V502.982Z",
    fill: "#F0F0F0"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 509.762H399.499V513.801H403.537V509.762Z",
    fill: "#F0F0F0"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 516.542H399.499V520.581H403.537V516.542Z",
    fill: "#F0F0F0"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 523.322H399.499V527.361H403.537V523.322Z",
    fill: "#F0F0F0"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 530.102H399.499V534.141H403.537V530.102Z",
    fill: "#F0F0F0"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 536.882H399.499V540.921H403.537V536.882Z",
    fill: "#F0F0F0"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 543.662H399.499V547.701H403.537V543.662Z",
    fill: "#F0F0F0"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M403.537 550.442H399.499V554.481H403.537V550.442Z",
    fill: "#F0F0F0"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 421.655H393.092V425.694H397.13V421.655Z",
    fill: "#F0F0F0"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 428.419H393.092V432.458H397.13V428.419Z",
    fill: "#F0F0F0"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 435.199H393.092V439.237H397.13V435.199Z",
    fill: "#F0F0F0"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 441.979H393.092V446.018H397.13V441.979Z",
    fill: "#F0F0F0"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 448.759H393.092V452.798H397.13V448.759Z",
    fill: "#F0F0F0"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 455.539H393.092V459.577H397.13V455.539Z",
    fill: "#F0F0F0"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 462.319H393.092V466.357H397.13V462.319Z",
    fill: "#F0F0F0"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 469.099H393.092V473.137H397.13V469.099Z",
    fill: "#F0F0F0"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 475.879H393.092V479.917H397.13V475.879Z",
    fill: "#F0F0F0"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 482.658H393.092V486.697H397.13V482.658Z",
    fill: "#F0F0F0"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 489.438H393.092V493.477H397.13V489.438Z",
    fill: "#F0F0F0"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 496.202H393.092V500.241H397.13V496.202Z",
    fill: "#F0F0F0"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 502.982H393.092V507.021H397.13V502.982Z",
    fill: "#F0F0F0"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 509.762H393.092V513.801H397.13V509.762Z",
    fill: "#F0F0F0"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 516.542H393.092V520.581H397.13V516.542Z",
    fill: "#F0F0F0"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 523.322H393.092V527.361H397.13V523.322Z",
    fill: "#F0F0F0"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 530.102H393.092V534.141H397.13V530.102Z",
    fill: "#F0F0F0"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 536.882H393.092V540.921H397.13V536.882Z",
    fill: "#F0F0F0"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 543.662H393.092V547.701H397.13V543.662Z",
    fill: "#F0F0F0"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M397.13 550.442H393.092V554.481H397.13V550.442Z",
    fill: "#F0F0F0"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M435.183 448.045H431.144V452.084H435.183V448.045Z",
    fill: "#F0F0F0"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M435.183 454.825H431.144V458.864H435.183V454.825Z",
    fill: "#F0F0F0"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M435.183 461.605H431.144V465.644H435.183V461.605Z",
    fill: "#F0F0F0"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M435.183 468.385H431.144V472.424H435.183V468.385Z",
    fill: "#F0F0F0"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M435.183 475.165H431.144V479.204H435.183V475.165Z",
    fill: "#F0F0F0"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M435.183 481.945H431.144V485.984H435.183V481.945Z",
    fill: "#F0F0F0"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M435.183 488.725H431.144V492.764H435.183V488.725Z",
    fill: "#F0F0F0"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M435.183 495.489H431.144V499.527H435.183V495.489Z",
    fill: "#F0F0F0"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M435.183 502.269H431.144V506.307H435.183V502.269Z",
    fill: "#F0F0F0"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M435.183 509.048H431.144V513.087H435.183V509.048Z",
    fill: "#F0F0F0"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M428.759 448.045H424.721V452.084H428.759V448.045Z",
    fill: "#F0F0F0"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M428.759 454.825H424.721V458.864H428.759V454.825Z",
    fill: "#F0F0F0"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M428.759 461.605H424.721V465.644H428.759V461.605Z",
    fill: "#F0F0F0"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M428.759 468.385H424.721V472.424H428.759V468.385Z",
    fill: "#F0F0F0"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M428.759 475.165H424.721V479.204H428.759V475.165Z",
    fill: "#F0F0F0"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M428.759 481.945H424.721V485.984H428.759V481.945Z",
    fill: "#F0F0F0"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M428.759 488.725H424.721V492.764H428.759V488.725Z",
    fill: "#F0F0F0"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M428.759 495.489H424.721V499.527H428.759V495.489Z",
    fill: "#F0F0F0"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M428.759 502.269H424.721V506.307H428.759V502.269Z",
    fill: "#F0F0F0"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M466.958 190.812H460.178V568.868H466.958V190.812Z",
    fill: "#E0E0E0"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M594.625 190.812H587.845V568.868H594.625V190.812Z",
    fill: "#E0E0E0"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M722.277 190.812H715.497V568.868H722.277V190.812Z",
    fill: "#E0E0E0"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M239.764 532.016H281.579C283.476 532.016 285.296 532.769 286.637 534.111C287.979 535.452 288.732 537.272 288.732 539.169V619.993H232.627V539.234C232.619 538.29 232.797 537.355 233.151 536.48C233.506 535.606 234.03 534.81 234.694 534.14C235.357 533.469 236.146 532.936 237.017 532.571C237.887 532.207 238.821 532.018 239.764 532.016Z",
    fill: "#F0F0F0"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M288.732 543.986H232.627V550.296H288.732V543.986Z",
    fill: "#E6E6E6"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M264.532 609.401H278.514C279.533 609.401 280.511 609.806 281.232 610.527C281.953 611.248 282.358 612.226 282.358 613.246V620.058H260.672V613.246C260.672 612.739 260.772 612.238 260.966 611.771C261.16 611.303 261.445 610.879 261.803 610.522C262.162 610.164 262.588 609.882 263.056 609.689C263.524 609.497 264.026 609.399 264.532 609.401Z",
    fill: "#E0E0E0"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M282.423 620.058H266.884C266.221 620.058 265.586 619.795 265.118 619.327C264.649 618.858 264.386 618.223 264.386 617.56C264.39 616.901 264.655 616.269 265.123 615.804C265.591 615.34 266.224 615.079 266.884 615.079H282.423C283.082 615.079 283.715 615.34 284.183 615.804C284.651 616.269 284.916 616.901 284.921 617.56C284.921 618.223 284.657 618.858 284.189 619.327C283.72 619.795 283.085 620.058 282.423 620.058Z",
    fill: "#E6E6E6"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M531.552 173.075C552.084 168.229 564.8 147.656 559.954 127.124C555.108 106.592 534.535 93.8756 514.003 98.7216C493.471 103.568 480.755 124.141 485.601 144.673C490.447 165.205 511.02 177.921 531.552 173.075Z",
    fill: "#E0E0E0"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M527.973 167.923C545.684 165.048 557.711 148.359 554.836 130.648C551.961 112.937 535.273 100.91 517.562 103.785C499.851 106.66 487.824 123.348 490.699 141.059C493.573 158.77 510.262 170.797 527.973 167.923Z",
    fill: "#F0F0F0"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M524.312 113.589V136.297L539.347 127.781",
    fill: "#F0F0F0"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M524.312 137.87C524.02 137.87 523.735 137.791 523.484 137.643C523.242 137.499 523.042 137.295 522.902 137.051C522.763 136.806 522.69 136.529 522.69 136.248V113.54C522.69 113.11 522.86 112.697 523.165 112.393C523.469 112.089 523.881 111.918 524.312 111.918C524.742 111.918 525.154 112.089 525.458 112.393C525.763 112.697 525.934 113.11 525.934 113.54V133.507L538.553 126.37C538.927 126.16 539.37 126.107 539.783 126.222C540.197 126.338 540.547 126.613 540.759 126.986C540.97 127.359 541.026 127.8 540.913 128.213C540.801 128.626 540.529 128.978 540.158 129.192L525.106 137.708C524.858 137.823 524.585 137.878 524.312 137.87Z",
    fill: "#E0E0E0"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M157.22 508.724C154.301 503.858 149.5 508.092 149.5 508.092C150.181 498.879 141.714 492.585 141.714 492.585C141.714 492.585 151.56 492.585 152.922 483.194C154.285 473.802 149.5 478.166 144.991 478.101C140.481 478.036 135.761 491.207 141.747 498.619C147.732 506.032 146.094 518.683 132.355 530.848C129.07 533.923 126.605 537.77 125.186 542.04C126.224 530.864 126.808 515.115 123.564 504.604C117.984 486.762 128.625 481.896 131.674 473.008C134.723 464.119 123.564 456.528 123.564 456.528C123.564 456.528 134.123 451.662 128.965 446.228C123.807 440.795 113.167 441.476 113.167 448.661C113.167 455.847 120.385 458.588 120.385 458.588C120.385 458.588 128.625 467.169 128.625 471.564C128.625 475.96 120.385 485.643 120.385 485.643C120.385 485.643 124.164 477.42 116.606 477.079C109.047 476.738 106.647 486.681 109.745 491.142C112.843 495.602 117.984 491.839 117.984 491.839C118.307 497.046 119.094 502.214 120.336 507.281C121.115 509.86 120.758 519.932 120.109 530.41C118.675 526.627 116.382 523.229 113.41 520.484C99.6719 508.319 98.0823 495.667 104.035 488.254C109.988 480.842 105.268 467.671 100.791 467.736C96.3144 467.801 91.4646 463.422 92.8433 472.813C94.222 482.204 104.068 482.221 104.068 482.221C104.068 482.221 95.5845 488.514 96.2657 497.727C96.2657 497.727 91.3997 493.542 88.545 498.36C83.3384 506.94 95.4223 512.26 97.4498 508.092C97.4498 508.092 123.061 526.225 116.914 552.323L118.341 554.448C118.163 556.557 118.049 557.822 118.049 557.822L120.044 556.962L122.331 560.32C122.251 564.114 122.446 567.908 122.915 571.674L129.03 562.623C122.85 536.525 148.494 518.391 148.494 518.391C150.359 522.641 162.427 517.305 157.22 508.724Z",
    fill: "#E0E0E0"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.22 508.724C154.301 503.858 149.5 508.092 149.5 508.092C150.181 498.879 141.714 492.585 141.714 492.585C141.714 492.585 151.56 492.585 152.922 483.194C154.285 473.802 149.5 478.166 144.991 478.101C140.481 478.036 135.761 491.207 141.747 498.619C147.732 506.032 146.094 518.683 132.355 530.848C129.07 533.923 126.605 537.77 125.186 542.04C126.224 530.864 126.808 515.115 123.564 504.604C117.984 486.762 128.625 481.896 131.674 473.008C134.723 464.119 123.564 456.528 123.564 456.528C123.564 456.528 134.123 451.662 128.965 446.228C123.807 440.795 113.167 441.476 113.167 448.661C113.167 455.847 120.385 458.588 120.385 458.588C120.385 458.588 128.625 467.169 128.625 471.564C128.625 475.96 120.385 485.643 120.385 485.643C120.385 485.643 124.164 477.42 116.606 477.079C109.047 476.738 106.647 486.681 109.745 491.142C112.843 495.602 117.984 491.839 117.984 491.839C118.307 497.046 119.094 502.214 120.336 507.281C121.115 509.86 120.758 519.932 120.109 530.41C118.675 526.627 116.382 523.229 113.41 520.484C99.6719 508.319 98.0823 495.667 104.035 488.254C109.988 480.842 105.268 467.671 100.791 467.736C96.3144 467.801 91.4646 463.422 92.8433 472.813C94.222 482.204 104.068 482.221 104.068 482.221C104.068 482.221 95.5845 488.514 96.2657 497.727C96.2657 497.727 91.3997 493.542 88.545 498.36C83.3384 506.94 95.4223 512.26 97.4498 508.092C97.4498 508.092 123.061 526.225 116.914 552.323L118.341 554.448C118.163 556.557 118.049 557.822 118.049 557.822L120.044 556.962L122.331 560.32C122.251 564.114 122.446 567.908 122.915 571.674L129.03 562.623C122.85 536.525 148.494 518.391 148.494 518.391C150.359 522.641 162.427 517.305 157.22 508.724Z",
    fill: "#E0E0E0"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M152.208 620.058H93.5407L87.2149 555.827H158.55L152.208 620.058Z",
    fill: "#E6E6E6"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M161.665 548.739H84.0683V562.915H161.665V548.739Z",
    fill: "#F0F0F0"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M588.981 639.603L542.251 635.013V569.322H523.728V634.981L476.868 639.603C474.621 639.825 472.536 640.874 471.019 642.546C469.503 644.219 468.662 646.396 468.661 648.654V655.677H597.253V648.654C597.254 646.385 596.405 644.197 594.874 642.522C593.343 640.847 591.241 639.806 588.981 639.603Z",
    fill: "#263238"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M588.981 639.603L542.251 635.013V569.322H523.728V634.981L476.868 639.603C474.621 639.825 472.536 640.874 471.019 642.546C469.503 644.219 468.662 646.396 468.661 648.654V655.677H597.253V648.654C597.254 646.385 596.405 644.197 594.874 642.522C593.343 640.847 591.241 639.806 588.981 639.603Z",
    fill: "white"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M473.543 676.504C480.235 676.504 485.659 671.079 485.659 664.388C485.659 657.696 480.235 652.271 473.543 652.271C466.851 652.271 461.427 657.696 461.427 664.388C461.427 671.079 466.851 676.504 473.543 676.504Z",
    fill: "#263238"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M592.257 676.504C598.949 676.504 604.373 671.079 604.373 664.388C604.373 657.696 598.949 652.271 592.257 652.271C585.565 652.271 580.141 657.696 580.141 664.388C580.141 671.079 585.565 676.504 592.257 676.504Z",
    fill: "#263238"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M520.548 524.944H545.446V576.735C545.446 578.511 544.74 580.215 543.484 581.471C542.228 582.728 540.524 583.433 538.747 583.433H527.247C525.471 583.433 523.767 582.728 522.511 581.471C521.254 580.215 520.548 578.511 520.548 576.735V524.944Z",
    fill: "#263238"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M520.548 524.944H545.446V576.735C545.446 578.511 544.74 580.215 543.484 581.471C542.228 582.728 540.524 583.433 538.747 583.433H527.247C525.471 583.433 523.767 582.728 522.511 581.471C521.254 580.215 520.548 578.511 520.548 576.735V524.944Z",
    fill: "white"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M577.27 422.288C577.27 422.288 580.806 509.876 556.411 524.944H584.261C584.261 524.944 605.833 495.116 599.734 422.288H577.27Z",
    fill: "#263238"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M577.27 422.288C577.27 422.288 580.806 509.876 556.411 524.944H584.261C584.261 524.944 605.833 495.116 599.734 422.288H577.27Z",
    fill: "white"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M593.733 531.659H468.969V520.808C468.969 518.657 469.823 516.594 471.344 515.073C472.865 513.552 474.928 512.698 477.079 512.698H585.623C587.774 512.698 589.837 513.552 591.358 515.073C592.879 516.594 593.733 518.657 593.733 520.808V531.659Z",
    fill: "#263238"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M467.022 531.659H595.663C597.464 531.659 598.924 530.2 598.924 528.399V525.447C598.924 523.646 597.464 522.187 595.663 522.187H467.022C465.222 522.187 463.762 523.646 463.762 525.447V528.399C463.762 530.2 465.222 531.659 467.022 531.659Z",
    fill: "#263238"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M467.022 531.659H595.663C597.464 531.659 598.924 530.2 598.924 528.399V525.447C598.924 523.646 597.464 522.187 595.663 522.187H467.022C465.222 522.187 463.762 523.646 463.762 525.447V528.399C463.762 530.2 465.222 531.659 467.022 531.659Z",
    fill: "white"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M606.563 375.331H561.958C548.897 375.331 538.309 385.919 538.309 398.98V416.432C538.309 429.493 548.897 440.081 561.958 440.081H606.563C619.624 440.081 630.212 429.493 630.212 416.432V398.98C630.212 385.919 619.624 375.331 606.563 375.331Z",
    fill: "#263238"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M426.667 303.768L417.762 280.298C417.762 280.298 421.59 276.762 418.963 273.177C416.335 269.593 399.92 259.52 396.936 261.288C393.951 263.056 387.285 269.739 390.886 273.453C394.487 277.167 410.35 283.347 410.35 283.347L418.233 314.165L426.667 303.768Z",
    fill: "#E4897B"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M488.838 348.389C488.838 348.389 448.288 340.068 443.958 338.073C439.627 336.078 423.342 288.343 423.342 288.343L410.836 294.182C410.836 294.182 420.893 342.096 431.176 353.482C441.46 364.869 485.351 374.568 485.351 374.568L488.838 348.389Z",
    fill: "#ECEFF1"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M485.254 374.52L484.508 374.341C482.302 373.838 475.376 372.216 467.152 369.8C453.803 365.923 436.967 360.068 431.095 353.499C420.828 342.145 410.755 294.182 410.755 294.182L423.245 288.343C423.245 288.343 439.546 336.094 443.958 338.073C448.369 340.052 488.838 348.389 488.838 348.389L485.254 374.52Z",
    fill: "black"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M423.456 287.402L426.034 292.382L409.977 297.913L410.593 291.83L423.456 287.402Z",
    fill: "#ECEFF1"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M485.562 373.855C483.324 373.53 476.3 372.444 467.898 370.611C472.683 362.339 486.697 358.089 486.697 358.089L485.562 373.855Z",
    fill: "black"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M545.933 315.333C545.933 315.333 548.317 337.765 540.012 343.28C531.708 348.795 490.817 342.339 486.178 333.305C481.539 324.27 498.992 299.778 498.992 299.778L545.933 315.333Z",
    fill: "#263238"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M380.505 610.505L391.178 613.084L396.579 598.356L401.477 584.958L389.329 579.784L384.657 596.036L380.505 610.505Z",
    fill: "#E4897B"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M384.657 596.036L396.579 598.356L401.477 584.958L389.329 579.784L384.657 596.036Z",
    fill: "black"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M385.728 588.267L400.52 593.766C400.52 593.766 439.984 495.099 448.094 494.824C456.204 494.548 538.78 532.438 559.476 511.384C580.173 490.331 550.247 439.562 550.247 439.562C550.247 439.562 500.468 432.458 496.721 443.698C495.799 447.011 495.095 450.382 494.613 453.787C494.045 457.226 493.656 460.113 493.656 460.113C492.115 459.723 442.141 446.829 422.45 460.113C402.418 473.624 385.728 588.267 385.728 588.267Z",
    fill: "#ECEFF1"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M385.728 588.267L400.52 593.766C400.52 593.766 439.984 495.099 448.094 494.824C456.204 494.548 538.78 532.438 559.476 511.384C580.173 490.331 550.247 439.562 550.247 439.562C550.247 439.562 500.468 432.458 496.721 443.698C495.799 447.011 495.095 450.382 494.613 453.787C494.045 457.226 493.656 460.113 493.656 460.113C492.115 459.723 442.141 446.829 422.45 460.113C402.418 473.624 385.728 588.267 385.728 588.267Z",
    fill: "white"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M470.818 652.595L481.442 649.887L479.398 634.624L477.501 620.642L464.362 621.826L467.769 638.127L470.818 652.595Z",
    fill: "#E4897B"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M467.85 638.452L479.463 634.916L477.533 620.788L464.379 621.907L467.85 638.452Z",
    fill: "black"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M406.635 588.283L385.079 580.968L384.154 589.791L400.504 595.566L406.635 588.283Z",
    fill: "#ECEFF1"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M523.728 516.38C523.728 516.38 520.354 516.461 468.142 514.028C468.142 514.028 475.943 579.297 480.209 628.168L464.589 630.828C464.589 630.828 427.283 526.193 427.689 509.567C428.094 492.942 447.153 488.076 447.153 488.076C447.153 488.076 484.345 509.567 523.728 516.38Z",
    fill: "#ECEFF1"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M523.728 516.38C523.728 516.38 520.354 516.461 468.142 514.028C468.142 514.028 475.943 579.297 480.209 628.168L464.589 630.828C464.589 630.828 427.283 526.193 427.689 509.567C428.094 492.942 447.153 488.076 447.153 488.076C447.153 488.076 484.345 509.567 523.728 516.38Z",
    fill: "white"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M523.728 516.38C523.728 516.38 520.354 516.461 468.142 514.028C468.142 514.028 475.943 579.297 480.209 628.168L464.589 630.828C464.589 630.828 427.283 526.193 427.689 509.567C428.094 492.942 447.153 488.076 447.153 488.076C447.153 488.076 484.345 509.567 523.728 516.38Z",
    fill: "black"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M482.48 623.432L461.021 625.881L465.173 634.283L482.545 632.061L482.48 623.432Z",
    fill: "#ECEFF1"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M493.656 460.113L522.771 466.179C522.771 466.179 506.68 457.29 494.613 453.787C494.045 457.226 493.656 460.113 493.656 460.113Z",
    fill: "black"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M549.047 431.825L550.247 439.562L496.721 443.698L495.31 434.534L549.047 431.825Z",
    fill: "#263238"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M549.047 431.825L550.247 439.562L496.721 443.698L495.31 434.534L549.047 431.825Z",
    fill: "black"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M532.165 444.788L534.811 444.516L533.426 431.043L530.78 431.315L532.165 444.788Z",
    fill: "#ECEFF1"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M508.386 443.442L520.105 442.688L519.533 433.802L507.814 434.556L508.386 443.442Z",
    fill: "white"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M499.324 446.203L501.97 445.931L500.585 432.459L497.939 432.731L499.324 446.203Z",
    fill: "#ECEFF1"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M532.165 444.788L534.811 444.516L533.426 431.043L530.78 431.315L532.165 444.788Z",
    fill: "white"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M499.324 446.203L501.97 445.931L500.585 432.459L497.939 432.731L499.324 446.203Z",
    fill: "white"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M487.865 347.659C497.891 350.429 508.295 351.573 518.683 351.049C535.876 350.174 556.346 358.462 556.346 358.462L548.982 431.776L495.229 434.485C495.229 434.485 477.241 373.319 487.865 347.659Z",
    fill: "#ECEFF1"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M496.51 306.25C496.51 306.25 499.527 270.663 529.275 283.542C566.581 299.762 536.931 343.134 518.683 334.245C500.436 325.357 496.51 306.25 496.51 306.25Z",
    fill: "#263238"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M504.848 353.045L505.707 373.157L512.374 363.701C512.374 363.701 509.989 385.939 511.384 398.055C511.384 398.055 512.666 376.336 515.682 363.701L522.771 373.157L532.941 353.174C532.941 353.174 516.477 347.254 504.848 353.045Z",
    fill: "black"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M514.06 356.84L529.453 352.493C519.965 346.005 524.749 331.407 524.749 331.407L509.503 336.76C510.204 338.879 510.746 341.048 511.125 343.248C512.747 352.752 508.432 353.515 508.432 353.515L514.06 356.84Z",
    fill: "#E4897B"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M509.503 336.679C510.204 338.798 510.746 340.967 511.125 343.167C518.424 340.231 524.733 331.293 524.733 331.293L509.503 336.679Z",
    fill: "black"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M519.462 291.068C505.95 288.083 499.998 294.312 495.943 308.034C490.866 325.146 491.985 338.349 509.681 338.382C533.719 338.414 541.878 296.031 519.462 291.068Z",
    fill: "#E4897B"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M504.831 309.218C503.31 310.995 501.578 312.58 499.673 313.938C499.946 314.588 500.393 315.149 500.966 315.558C501.539 315.968 502.215 316.21 502.917 316.257L504.831 309.218Z",
    fill: "#DE5753"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M513.347 309.932C513.071 311.035 513.444 312.089 514.19 312.267C514.936 312.446 515.731 311.7 516.007 310.645C516.283 309.591 515.91 308.504 515.163 308.31C514.417 308.115 513.623 308.829 513.347 309.932Z",
    fill: "#263238"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M515.455 308.391L513.298 306.866C513.298 306.866 513.996 309.186 515.455 308.391Z",
    fill: "#263238"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M499.69 306.331C499.414 307.434 499.787 308.488 500.533 308.667C501.279 308.845 502.155 308.099 502.35 307.045C502.544 305.99 502.252 304.904 501.506 304.709C500.76 304.514 499.965 305.228 499.69 306.331Z",
    fill: "#263238"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M501.798 304.79L499.576 303.314C499.576 303.314 500.338 305.569 501.798 304.79Z",
    fill: "#263238"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M520.954 304.563C520.845 304.565 520.738 304.537 520.644 304.483C520.549 304.429 520.472 304.35 520.419 304.255C519.884 303.42 519.17 302.716 518.328 302.194C517.486 301.672 516.538 301.345 515.553 301.238C515.398 301.218 515.257 301.139 515.157 301.019C515.058 300.898 515.008 300.745 515.017 300.589C515.034 300.433 515.111 300.289 515.232 300.189C515.354 300.089 515.51 300.04 515.666 300.054C516.862 300.169 518.014 300.561 519.033 301.197C520.052 301.833 520.909 302.696 521.538 303.719C521.574 303.789 521.596 303.864 521.602 303.942C521.609 304.019 521.6 304.098 521.576 304.172C521.551 304.246 521.513 304.314 521.462 304.373C521.411 304.432 521.348 304.48 521.278 304.514C521.175 304.555 521.064 304.572 520.954 304.563Z",
    fill: "#263238"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M505.853 298.448C505.743 298.446 505.636 298.412 505.545 298.351C504.748 297.968 503.875 297.769 502.99 297.769C502.106 297.769 501.233 297.968 500.436 298.351C500.366 298.379 500.29 298.394 500.214 298.393C500.139 298.392 500.064 298.376 499.994 298.346C499.925 298.316 499.862 298.272 499.81 298.217C499.757 298.162 499.716 298.097 499.69 298.026C499.661 297.955 499.646 297.879 499.647 297.802C499.647 297.725 499.663 297.648 499.693 297.578C499.723 297.507 499.767 297.442 499.822 297.389C499.877 297.335 499.942 297.292 500.014 297.264C500.983 296.813 502.042 296.59 503.111 296.613C504.179 296.635 505.228 296.902 506.178 297.394C506.243 297.435 506.299 297.489 506.344 297.552C506.388 297.615 506.419 297.686 506.436 297.762C506.453 297.837 506.454 297.915 506.44 297.991C506.427 298.067 506.398 298.14 506.356 298.205C506.298 298.283 506.222 298.346 506.135 298.388C506.047 298.431 505.95 298.451 505.853 298.448Z",
    fill: "#263238"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M529.177 317.085C529.177 317.085 525.317 304.595 528.172 296.242C528.172 296.242 503.842 279.389 496.51 306.25C496.51 306.25 499.219 281.563 522.56 286.169C545.9 290.776 538.261 324.692 524.036 332.153C524.036 332.153 531.546 324.886 529.177 317.085Z",
    fill: "#263238"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M526.339 319.534C526.814 317.999 527.878 316.716 529.298 315.965C530.718 315.214 532.378 315.056 533.914 315.528C538.001 316.906 538.082 325.941 527.231 325.698C525.658 325.584 525.139 323.946 526.339 319.534Z",
    fill: "#E4897B"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M500.468 321.383C500.829 323.039 501.068 324.72 501.182 326.411H502.058C506.096 326.752 508.075 325.568 509.048 324.173C509.514 323.48 509.803 322.683 509.892 321.853C509.96 321.385 509.96 320.91 509.892 320.442C507.288 321.339 504.523 321.665 501.782 321.399C501.003 321.448 500.468 321.383 500.468 321.383Z",
    fill: "#263238"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M501.847 321.48L502.09 322.956C505.886 323.265 508.578 322.956 509.892 321.935C509.96 321.467 509.96 320.991 509.892 320.523C507.309 321.411 504.566 321.737 501.847 321.48Z",
    fill: "white"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M502.058 326.492C506.096 326.833 508.075 325.649 509.048 324.254C507.517 324.154 505.98 324.324 504.507 324.757C503.528 325.063 502.671 325.67 502.058 326.492Z",
    fill: "#DE5753"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M519.51 292.154C519.51 292.154 520.029 315.56 534.108 318.382C548.187 321.204 532.811 288.278 532.811 288.278C532.811 288.278 511.887 274.621 497.938 284.255C483.989 293.89 496.543 306.25 496.543 306.25C496.543 306.25 499.446 288.862 519.51 292.154Z",
    fill: "#263238"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M524.879 313.581C524.784 313.58 524.692 313.546 524.62 313.484C514.628 305.633 519.559 290.614 519.608 290.468C519.645 290.366 519.719 290.283 519.816 290.234C519.912 290.186 520.023 290.177 520.127 290.208C520.228 290.245 520.31 290.32 520.356 290.417C520.401 290.515 520.407 290.626 520.37 290.727C520.37 290.873 515.585 305.325 525.123 312.851C525.161 312.888 525.192 312.932 525.213 312.981C525.234 313.029 525.245 313.082 525.245 313.135C525.245 313.188 525.234 313.241 525.213 313.29C525.192 313.339 525.161 313.383 525.123 313.419C525.096 313.462 525.06 313.498 525.018 313.526C524.976 313.554 524.929 313.573 524.879 313.581Z",
    fill: "#263238"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M538.18 323.183C536.395 327.952 531.805 330.628 527.929 329.185C524.052 327.741 522.365 322.697 524.149 317.928C525.933 313.159 530.524 310.483 534.4 311.943C538.277 313.403 539.964 318.431 538.18 323.183Z",
    fill: "#ECEFF1"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M538.18 323.183C536.395 327.952 531.805 330.628 527.929 329.185C524.052 327.741 522.365 322.697 524.149 317.928C525.933 313.159 530.524 310.483 534.4 311.943C538.277 313.403 539.964 318.431 538.18 323.183Z",
    fill: "black"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M533.638 315.382C533.638 315.382 539.461 289.316 526.404 282.488C527.891 282.682 529.364 282.969 530.816 283.347C532.438 283.834 542.932 294.409 537.661 317.831L533.638 315.382Z",
    fill: "#ECEFF1"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M533.638 315.382C533.638 315.382 539.461 289.316 526.404 282.488C527.891 282.682 529.364 282.969 530.816 283.347C532.438 283.834 542.932 294.409 537.661 317.831L533.638 315.382Z",
    fill: "black"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M509.308 330.304L508.335 330.158L508.594 328.536C515.758 329.638 523.077 328.086 529.177 324.173L530.134 325.47C524 329.535 516.606 331.252 509.308 330.304Z",
    fill: "#ECEFF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.308 330.304L508.335 330.158L508.594 328.536C515.758 329.638 523.077 328.086 529.177 324.173L530.134 325.47C524 329.535 516.606 331.252 509.308 330.304Z",
    fill: "black"
  }))), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M537.628 322.535C536.46 325.681 533.411 327.401 530.864 326.492C528.318 325.584 527.182 322.21 528.366 319.064C529.551 315.917 532.584 314.198 535.13 315.106C537.677 316.014 538.812 319.388 537.628 322.535Z",
    fill: "#ECEFF1"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M507.783 330.888L506.469 330.709C506.24 330.68 506.019 330.604 505.819 330.489C505.618 330.373 505.443 330.218 505.303 330.034C505.163 329.85 505.06 329.64 505.002 329.417C504.943 329.193 504.929 328.96 504.961 328.731C504.989 328.5 505.063 328.277 505.178 328.075C505.293 327.873 505.447 327.695 505.631 327.554C505.815 327.412 506.026 327.308 506.25 327.248C506.475 327.188 506.71 327.174 506.94 327.206L508.237 327.384C508.7 327.449 509.119 327.692 509.404 328.062C509.689 328.432 509.818 328.899 509.762 329.363C509.698 329.826 509.454 330.245 509.084 330.53C508.714 330.815 508.247 330.943 507.783 330.888Z",
    fill: "#ECEFF1"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M507.783 330.888L506.469 330.709C506.24 330.68 506.019 330.604 505.819 330.489C505.618 330.373 505.443 330.218 505.303 330.034C505.163 329.85 505.06 329.64 505.002 329.417C504.943 329.193 504.929 328.96 504.961 328.731C504.989 328.5 505.063 328.277 505.178 328.075C505.293 327.873 505.447 327.695 505.631 327.554C505.815 327.412 506.026 327.308 506.25 327.248C506.475 327.188 506.71 327.174 506.94 327.206L508.237 327.384C508.7 327.449 509.119 327.692 509.404 328.062C509.689 328.432 509.818 328.899 509.762 329.363C509.698 329.826 509.454 330.245 509.084 330.53C508.714 330.815 508.247 330.943 507.783 330.888Z",
    fill: "black"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M525.317 346.865L515.682 356.321L519.543 367.935L532.941 353.174L525.317 346.865Z",
    fill: "#ECEFF1"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M511.384 348.844L512.941 356.126L507.962 366.426L504.848 353.044L511.384 348.844Z",
    fill: "#ECEFF1"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M523.257 355.072L528.853 334.586C528.853 334.586 526.144 329.493 526.728 328.422C527.312 327.352 530.232 313.597 532.308 312.105C534.384 310.613 542.932 313.159 543.792 314.554C544.651 315.949 535.601 334.586 535.601 334.586L532.357 356.791L523.257 355.072Z",
    fill: "#E4897B"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M556.346 358.462C571.755 374.228 540.888 409.944 523.192 408.419C505.496 406.895 523.646 342.145 523.646 342.145L535 344.01C535 344.01 531.027 372.038 532.276 374.228C533.524 376.417 551.237 353.223 556.346 358.462Z",
    fill: "#ECEFF1"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M556.346 358.462C571.755 374.228 540.888 409.944 523.192 408.419C505.496 406.895 523.646 342.145 523.646 342.145L535 344.01C535 344.01 531.027 372.038 532.276 374.228C533.524 376.417 551.237 353.223 556.346 358.462Z",
    fill: "black"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M522.771 340.117L521.1 345.47L536.882 346.865V342.193L522.771 340.117Z",
    fill: "#ECEFF1"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M498.846 382.468H492.455C491.748 382.468 491.174 383.041 491.174 383.749V395.817C491.174 396.524 491.748 397.098 492.455 397.098H498.846C499.554 397.098 500.127 396.524 500.127 395.817V383.749C500.127 383.041 499.554 382.468 498.846 382.468Z",
    fill: "white"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M498.976 383.441H491.709V393.384H498.976V383.441Z",
    fill: "black"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M496.316 378.948H494.71V384.803H496.316V378.948Z",
    fill: "#263238"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M362.858 631.234C364.475 630.481 366.219 630.035 367.999 629.92C367.999 629.92 374.163 626.303 380.262 612.208H387.123C388.286 612.216 389.419 612.583 390.365 613.26C391.312 613.936 392.026 614.889 392.41 615.987C392.525 616.288 392.591 616.606 392.605 616.928C392.524 618.586 392.345 620.238 392.07 621.875C391.066 627.358 389.728 632.775 388.064 638.095L386.896 637.803L389.004 627.552C389.718 624.081 386.052 627.438 384.365 630.942C382.678 634.445 380.067 637.997 372.476 636.262C363.636 634.088 360.084 632.823 362.858 631.234Z",
    fill: "#ECEFF1"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M381.511 608.526C381.511 608.526 372.93 626.465 367.999 629.92C367.999 629.92 374.617 633.861 381.511 625.054C390.415 613.7 392.605 616.863 392.605 616.863C392.418 614.904 392.055 612.966 391.518 611.072C390.188 607.439 381.511 608.526 381.511 608.526Z",
    fill: "#E4897B"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M457.29 673.973C458.692 672.869 460.279 672.023 461.978 671.476C461.978 671.476 467.104 666.496 469.683 651.363L476.349 649.741C477.48 649.48 478.665 649.574 479.741 650.009C480.818 650.444 481.734 651.2 482.367 652.174C482.549 652.444 482.691 652.739 482.788 653.05C483.113 654.656 483.335 656.281 483.453 657.916C483.765 663.459 483.738 669.017 483.372 674.557H482.172L481.799 664.112C481.653 660.56 478.912 664.696 478.084 668.507C477.257 672.319 475.587 676.358 467.801 676.471C458.734 676.569 454.971 676.179 457.29 673.973Z",
    fill: "#ECEFF1"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M470.023 647.486C470.023 647.486 465.952 666.95 461.913 671.475C461.913 671.475 469.277 673.746 473.884 663.576C479.852 650.438 482.723 653.001 482.723 653.001C482.082 651.142 481.273 649.345 480.307 647.632C478.198 644.388 470.023 647.486 470.023 647.486Z",
    fill: "#E4897B"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M620.837 254.897H564.213C559.671 254.897 555.989 258.579 555.989 263.121V287.337C555.989 291.879 559.671 295.561 564.213 295.561H620.837C625.379 295.561 629.06 291.879 629.06 287.337V263.121C629.06 258.579 625.379 254.897 620.837 254.897Z",
    fill: "#ECEFF1"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M575.567 290.922L558.503 314.116L586.029 292.479L575.567 290.922Z",
    fill: "#ECEFF1"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M576.199 275.221C576.202 275.697 576.064 276.163 575.801 276.561C575.539 276.958 575.164 277.268 574.725 277.452C574.286 277.635 573.802 277.684 573.334 277.592C572.867 277.5 572.438 277.271 572.101 276.934C571.765 276.598 571.536 276.169 571.444 275.701C571.351 275.234 571.4 274.75 571.584 274.311C571.768 273.872 572.078 273.497 572.475 273.234C572.872 272.972 573.339 272.833 573.815 272.836C574.447 272.836 575.054 273.088 575.501 273.535C575.948 273.982 576.199 274.588 576.199 275.221Z",
    fill: "white"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M588.672 275.221C588.676 275.697 588.537 276.163 588.275 276.561C588.012 276.958 587.637 277.268 587.198 277.452C586.759 277.635 586.275 277.684 585.808 277.592C585.34 277.5 584.911 277.271 584.574 276.934C584.238 276.598 584.009 276.169 583.917 275.701C583.825 275.234 583.874 274.75 584.057 274.311C584.241 273.872 584.551 273.497 584.948 273.234C585.346 272.972 585.812 272.833 586.288 272.836C586.92 272.836 587.527 273.088 587.974 273.535C588.421 273.982 588.672 274.588 588.672 275.221Z",
    fill: "white"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M601.146 275.221C601.149 275.697 601.01 276.163 600.748 276.561C600.485 276.958 600.111 277.268 599.671 277.452C599.232 277.635 598.748 277.684 598.281 277.592C597.814 277.5 597.384 277.271 597.048 276.934C596.711 276.598 596.482 276.169 596.39 275.701C596.298 275.234 596.347 274.75 596.53 274.311C596.714 273.872 597.024 273.497 597.422 273.234C597.819 272.972 598.285 272.833 598.761 272.836C599.394 272.836 600 273.088 600.447 273.535C600.894 273.982 601.146 274.588 601.146 275.221Z",
    fill: "white"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M613.619 275.221C613.622 275.697 613.484 276.163 613.221 276.561C612.958 276.958 612.584 277.268 612.144 277.452C611.705 277.635 611.221 277.684 610.754 277.592C610.287 277.5 609.858 277.271 609.521 276.934C609.184 276.598 608.955 276.169 608.863 275.701C608.771 275.234 608.82 274.75 609.004 274.311C609.187 273.872 609.497 273.497 609.895 273.234C610.292 272.972 610.758 272.833 611.234 272.836C611.867 272.836 612.473 273.088 612.92 273.535C613.368 273.982 613.619 274.588 613.619 275.221Z",
    fill: "white"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M408.215 235.722L367.816 213.96C366.728 213.374 365.371 213.781 364.784 214.87L351.892 238.803C351.306 239.891 351.713 241.249 352.801 241.835L393.199 263.596C394.288 264.183 395.645 263.775 396.232 262.687L409.124 238.754C409.71 237.666 409.303 236.308 408.215 235.722Z",
    fill: "#ECEFF1"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M408.215 235.722L367.816 213.96C366.728 213.374 365.371 213.781 364.784 214.87L351.892 238.803C351.306 239.891 351.713 241.249 352.801 241.835L393.199 263.596C394.288 264.183 395.645 263.775 396.232 262.687L409.124 238.754C409.71 237.666 409.303 236.308 408.215 235.722Z",
    fill: "white"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M363.734 216.845L376.304 240.445C376.787 241.344 377.525 242.08 378.426 242.559C379.327 243.039 380.349 243.24 381.365 243.138L407.657 240.543L380.894 244.484C379.725 244.657 378.531 244.447 377.49 243.886C376.449 243.325 375.618 242.442 375.12 241.37L363.734 216.845Z",
    fill: "black"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M333.061 212.482C333.499 203.464 340.182 185.281 348.308 179.718C356.434 174.154 351.082 181.859 351.082 181.859C351.082 181.859 358.786 174.365 362.841 174.592C366.896 174.819 362.841 179.458 362.841 179.458C362.841 179.458 371.195 174.316 375.039 174.592C378.883 174.868 375.039 179.312 375.039 179.312C375.039 179.312 381.884 174.446 384.657 176.733C387.431 179.02 349.152 204.307 344.886 214.591C340.62 224.874 332.624 221.581 333.061 212.482Z",
    fill: "#ECEFF1"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M333.061 212.482C333.499 203.464 340.182 185.281 348.308 179.718C356.434 174.154 351.082 181.859 351.082 181.859C351.082 181.859 358.786 174.365 362.841 174.592C366.896 174.819 362.841 179.458 362.841 179.458C362.841 179.458 371.195 174.316 375.039 174.592C378.883 174.868 375.039 179.312 375.039 179.312C375.039 179.312 381.884 174.446 384.657 176.733C387.431 179.02 349.152 204.307 344.886 214.591C340.62 224.874 332.624 221.581 333.061 212.482Z",
    fill: "white"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M365.956 211.119L371.065 214.363C371.146 214.413 371.207 214.489 371.239 214.578C371.272 214.668 371.273 214.765 371.243 214.855C371.213 214.945 371.153 215.023 371.074 215.075C370.995 215.127 370.9 215.15 370.805 215.142L365.437 214.72L365.891 218.84C365.904 218.937 365.885 219.036 365.838 219.122C365.79 219.207 365.716 219.275 365.627 219.316C365.537 219.356 365.437 219.366 365.342 219.345C365.246 219.323 365.16 219.271 365.096 219.197L361.998 215.726L365.956 211.119Z",
    fill: "#ECEFF1"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M365.956 211.119L371.065 214.363C371.146 214.413 371.207 214.489 371.239 214.578C371.272 214.668 371.273 214.765 371.243 214.855C371.213 214.945 371.153 215.023 371.074 215.075C370.995 215.127 370.9 215.15 370.805 215.142L365.437 214.72L365.891 218.84C365.904 218.937 365.885 219.036 365.838 219.122C365.79 219.207 365.716 219.275 365.627 219.316C365.537 219.356 365.437 219.366 365.342 219.345C365.246 219.323 365.16 219.271 365.096 219.197L361.998 215.726L365.956 211.119Z",
    fill: "white"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M294.182 190.812C294.182 190.812 301.254 185.946 311.943 189.093C311.943 189.093 315.009 203.22 323.427 207.924C328.049 210.503 339.355 210.276 348.308 207.389C358.932 203.95 364.123 203.95 366.053 207.924C367.983 211.898 365.842 216.034 357.716 217.964C349.59 219.895 343.118 234.006 328.406 234.184C313.695 234.363 305.877 219.586 309.591 206.61C306.074 199.977 300.726 194.493 294.182 190.812Z",
    fill: "#ECEFF1"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M294.182 190.812C294.182 190.812 301.254 185.946 311.943 189.093C311.943 189.093 315.009 203.22 323.427 207.924C328.049 210.503 339.355 210.276 348.308 207.389C358.932 203.95 364.123 203.95 366.053 207.924C367.983 211.898 365.842 216.034 357.716 217.964C349.59 219.895 343.118 234.006 328.406 234.184C313.695 234.363 305.877 219.586 309.591 206.61C306.074 199.977 300.726 194.493 294.182 190.812Z",
    fill: "white"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M361.998 210.601C361.998 210.745 361.955 210.886 361.875 211.006C361.795 211.126 361.681 211.22 361.547 211.275C361.414 211.33 361.267 211.345 361.126 211.316C360.984 211.288 360.854 211.219 360.752 211.117C360.65 211.015 360.58 210.884 360.552 210.743C360.524 210.601 360.538 210.455 360.594 210.321C360.649 210.188 360.743 210.074 360.863 209.994C360.983 209.913 361.124 209.871 361.268 209.871C361.462 209.871 361.647 209.948 361.784 210.084C361.921 210.221 361.998 210.407 361.998 210.601Z",
    fill: "#263238"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M324.984 222.473C316.274 224.841 296.907 224.095 289.121 218.094C281.336 212.093 290.289 214.85 290.289 214.85C290.289 214.85 280.801 209.838 279.746 205.913C278.692 201.987 284.418 204.388 284.418 204.388C284.418 204.388 276.956 198.046 275.983 194.315C275.01 190.585 280.46 192.856 280.46 192.856C280.46 192.856 273.664 187.86 275.043 184.502C276.421 181.145 312.251 209.757 323.329 210.649C334.408 211.541 333.808 220.073 324.984 222.473Z",
    fill: "#ECEFF1"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M324.984 222.473C316.274 224.841 296.907 224.095 289.121 218.094C281.336 212.093 290.289 214.85 290.289 214.85C290.289 214.85 280.801 209.838 279.746 205.913C278.692 201.987 284.418 204.388 284.418 204.388C284.418 204.388 276.956 198.046 275.983 194.315C275.01 190.585 280.46 192.856 280.46 192.856C280.46 192.856 273.664 187.86 275.043 184.502C276.421 181.145 312.251 209.757 323.329 210.649C334.408 211.541 333.808 220.073 324.984 222.473Z",
    fill: "white"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M267.89 183.01C267.826 183.026 267.759 183.026 267.695 183.01C266.186 182.475 264.646 181.972 263.088 181.502C262.934 181.453 262.806 181.346 262.73 181.203C262.654 181.061 262.637 180.894 262.683 180.739C262.732 180.585 262.839 180.457 262.981 180.381C263.124 180.305 263.29 180.288 263.445 180.334C265.067 180.804 266.576 181.323 268.1 181.956C268.236 182.002 268.351 182.096 268.424 182.22C268.497 182.343 268.523 182.489 268.497 182.63C268.472 182.772 268.396 182.899 268.285 182.99C268.173 183.08 268.033 183.128 267.89 183.124V183.01Z",
    fill: "#ECEFF1"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M169.856 314.668C169.695 314.668 169.541 314.605 169.426 314.493C169.311 314.381 169.244 314.229 169.239 314.068C169.239 313.907 169.302 313.753 169.414 313.638C169.526 313.523 169.679 313.456 169.84 313.452C173.066 313.406 176.284 313.091 179.458 312.511C179.617 312.482 179.781 312.517 179.914 312.608C180.048 312.699 180.14 312.839 180.172 312.997C180.188 313.076 180.188 313.158 180.173 313.237C180.157 313.316 180.125 313.391 180.08 313.458C180.035 313.524 179.976 313.581 179.908 313.624C179.841 313.668 179.765 313.697 179.685 313.711C176.441 314.305 173.153 314.625 169.856 314.668ZM160.124 314.149C156.851 313.8 153.601 313.258 150.392 312.527C150.233 312.492 150.094 312.396 150.006 312.259C149.918 312.122 149.888 311.956 149.921 311.797C149.96 311.641 150.058 311.507 150.194 311.422C150.33 311.337 150.494 311.309 150.651 311.343C153.81 312.055 157.004 312.596 160.221 312.965C160.365 312.989 160.497 313.063 160.591 313.174C160.686 313.286 160.738 313.427 160.738 313.573C160.738 313.719 160.686 313.861 160.591 313.972C160.497 314.084 160.365 314.158 160.221 314.181L160.124 314.149ZM188.947 310.905C188.83 310.906 188.716 310.872 188.618 310.809C188.52 310.745 188.443 310.655 188.395 310.548C188.36 310.475 188.341 310.395 188.337 310.314C188.334 310.233 188.347 310.153 188.376 310.077C188.405 310.001 188.449 309.932 188.505 309.873C188.561 309.815 188.629 309.769 188.703 309.737C191.649 308.467 194.384 306.755 196.813 304.66C196.938 304.566 197.093 304.522 197.249 304.537C197.404 304.553 197.548 304.626 197.651 304.744C197.754 304.861 197.808 305.013 197.803 305.17C197.799 305.326 197.735 305.474 197.624 305.585C195.098 307.753 192.26 309.53 189.206 310.856C189.117 310.906 189.017 310.934 188.914 310.937L188.947 310.905ZM141.114 309.802C141.05 309.818 140.983 309.818 140.919 309.802C137.838 308.78 134.74 307.58 131.739 306.266C131.606 306.19 131.506 306.067 131.459 305.922C131.411 305.776 131.42 305.618 131.482 305.478C131.545 305.339 131.658 305.227 131.798 305.166C131.938 305.105 132.097 305.098 132.242 305.147C135.194 306.445 138.243 307.629 141.309 308.65C141.46 308.705 141.584 308.818 141.654 308.963C141.724 309.109 141.734 309.276 141.682 309.429C141.636 309.541 141.557 309.637 141.456 309.704C141.354 309.77 141.235 309.804 141.114 309.802ZM123.272 301.919C123.177 301.948 123.075 301.948 122.98 301.919C120.077 300.297 117.254 298.545 114.627 296.712C114.562 296.667 114.506 296.609 114.464 296.541C114.421 296.474 114.393 296.399 114.379 296.321C114.366 296.243 114.368 296.162 114.385 296.085C114.402 296.007 114.435 295.934 114.481 295.869C114.527 295.804 114.585 295.749 114.652 295.706C114.719 295.664 114.794 295.635 114.872 295.621C114.951 295.608 115.031 295.61 115.108 295.627C115.186 295.645 115.259 295.677 115.324 295.723C117.919 297.523 120.693 299.259 123.58 300.865C123.65 300.904 123.711 300.956 123.761 301.019C123.81 301.082 123.847 301.154 123.868 301.231C123.889 301.308 123.894 301.388 123.884 301.467C123.874 301.547 123.848 301.623 123.807 301.692C123.739 301.797 123.64 301.88 123.525 301.929C123.409 301.978 123.282 301.991 123.158 301.968L123.272 301.919ZM203.464 298.205C203.368 298.234 203.267 298.234 203.172 298.205C203.102 298.166 203.04 298.114 202.991 298.051C202.942 297.988 202.905 297.916 202.884 297.839C202.863 297.762 202.858 297.681 202.868 297.602C202.878 297.523 202.904 297.447 202.945 297.378C203.447 296.502 203.918 295.593 204.34 294.653C205.242 292.666 205.949 290.597 206.448 288.473C206.49 288.316 206.591 288.181 206.73 288.096C206.869 288.012 207.035 287.984 207.194 288.019C207.351 288.061 207.484 288.162 207.566 288.302C207.648 288.441 207.672 288.608 207.632 288.765C207.103 290.958 206.37 293.098 205.443 295.155C205.005 296.129 204.518 297.086 203.999 297.994C203.93 298.098 203.831 298.178 203.715 298.224C203.599 298.271 203.472 298.281 203.35 298.253L203.464 298.205ZM107.279 290.711C107.136 290.709 106.999 290.657 106.89 290.565C104.42 288.383 102.105 286.031 99.9639 283.526C99.8519 283.411 99.7892 283.256 99.7892 283.096C99.7892 282.935 99.8519 282.781 99.9639 282.666C100.076 282.555 100.228 282.493 100.386 282.493C100.543 282.493 100.695 282.555 100.807 282.666C102.91 285.119 105.181 287.422 107.603 289.559C107.715 289.675 107.778 289.829 107.778 289.989C107.778 290.15 107.715 290.304 107.603 290.419C107.563 290.507 107.502 290.584 107.426 290.643C107.35 290.702 107.261 290.742 107.166 290.76L107.279 290.711ZM208.135 279.454C208.055 279.454 207.975 279.438 207.902 279.407C207.828 279.376 207.761 279.33 207.705 279.273C207.649 279.215 207.605 279.147 207.576 279.073C207.547 278.998 207.533 278.918 207.535 278.838C207.511 275.612 207.213 272.395 206.643 269.22C206.614 269.061 206.649 268.897 206.74 268.763C206.831 268.63 206.971 268.537 207.129 268.506C207.29 268.482 207.454 268.521 207.587 268.614C207.72 268.708 207.811 268.849 207.843 269.009C208.427 272.253 208.731 275.542 208.751 278.838C208.751 279.002 208.686 279.158 208.571 279.274C208.455 279.389 208.299 279.454 208.135 279.454ZM204.891 260.217C204.76 260.216 204.632 260.173 204.527 260.094C204.422 260.015 204.345 259.905 204.307 259.78C203.48 256.941 202.458 253.924 201.209 250.55C201.178 250.475 201.163 250.394 201.164 250.313C201.165 250.231 201.183 250.151 201.217 250.076C201.25 250.002 201.298 249.935 201.358 249.88C201.418 249.825 201.489 249.782 201.566 249.756C201.717 249.703 201.882 249.71 202.027 249.777C202.173 249.843 202.286 249.964 202.344 250.112C203.61 253.519 204.632 256.6 205.475 259.423C205.521 259.578 205.504 259.744 205.428 259.887C205.352 260.029 205.223 260.136 205.069 260.185L204.891 260.217ZM198.176 241.808C198.063 241.809 197.953 241.777 197.858 241.717C197.763 241.656 197.688 241.569 197.641 241.467C196.603 238.872 195.191 235.887 193.715 232.725V232.562C193.673 232.421 193.683 232.269 193.743 232.134C193.803 232 193.91 231.891 194.044 231.828C194.177 231.765 194.329 231.753 194.471 231.792C194.613 231.831 194.736 231.921 194.818 232.043V232.206C196.311 235.45 197.706 238.385 198.744 240.932C198.809 241.085 198.812 241.257 198.751 241.412C198.69 241.567 198.571 241.692 198.419 241.759L198.176 241.808ZM190.066 223.966C189.947 223.97 189.829 223.938 189.728 223.874C189.626 223.81 189.547 223.718 189.498 223.609C188.038 220.219 186.871 217.218 185.946 214.445C185.894 214.292 185.904 214.125 185.974 213.979C186.043 213.834 186.167 213.721 186.319 213.666C186.474 213.615 186.643 213.627 186.789 213.7C186.935 213.773 187.046 213.901 187.098 214.055C188.006 216.797 189.158 219.765 190.617 223.122C190.649 223.196 190.666 223.275 190.667 223.355C190.668 223.435 190.653 223.514 190.623 223.588C190.592 223.662 190.548 223.729 190.491 223.786C190.434 223.842 190.367 223.887 190.293 223.917C190.239 223.975 190.172 224.019 190.098 224.047L190.066 223.966ZM184.129 205.378C183.984 205.376 183.845 205.322 183.735 205.228C183.625 205.133 183.552 205.002 183.529 204.859C183.251 203.121 183.11 201.363 183.108 199.603C183.094 198.031 183.235 196.461 183.529 194.916C183.576 194.772 183.674 194.65 183.805 194.574C183.935 194.498 184.09 194.472 184.238 194.502C184.386 194.532 184.518 194.616 184.609 194.737C184.7 194.858 184.743 195.008 184.73 195.159C184.449 196.624 184.313 198.112 184.324 199.603C184.33 201.303 184.465 203.001 184.73 204.68C184.749 204.838 184.708 204.998 184.615 205.127C184.522 205.257 184.383 205.346 184.227 205.378H184.129ZM188.363 186.952C188.222 186.956 188.084 186.91 187.974 186.822C187.862 186.707 187.799 186.553 187.799 186.392C187.799 186.232 187.862 186.077 187.974 185.962C190.151 183.418 192.8 181.32 195.775 179.782C195.918 179.707 196.084 179.69 196.239 179.735C196.393 179.781 196.524 179.885 196.603 180.026C196.673 180.171 196.685 180.337 196.637 180.491C196.589 180.645 196.484 180.774 196.343 180.853C193.51 182.318 190.988 184.317 188.914 186.741C188.861 186.83 188.785 186.905 188.694 186.956C188.603 187.007 188.5 187.034 188.395 187.033L188.363 186.952ZM253.762 179.004H253.632C250.518 178.355 247.29 177.804 244.03 177.382C243.951 177.372 243.874 177.346 243.805 177.307C243.736 177.267 243.676 177.214 243.627 177.15C243.579 177.087 243.544 177.014 243.524 176.937C243.504 176.86 243.499 176.78 243.511 176.701C243.521 176.622 243.546 176.545 243.586 176.476C243.626 176.407 243.679 176.347 243.743 176.298C243.806 176.25 243.878 176.215 243.956 176.195C244.033 176.175 244.113 176.17 244.192 176.182C247.436 176.603 250.68 177.155 253.924 177.804C254.07 177.837 254.198 177.922 254.285 178.043C254.373 178.164 254.413 178.313 254.399 178.462C254.386 178.61 254.318 178.749 254.21 178.851C254.102 178.954 253.96 179.014 253.811 179.02L253.762 179.004ZM205.102 177.625C205.023 177.634 204.943 177.627 204.867 177.604C204.791 177.582 204.72 177.545 204.659 177.495C204.597 177.446 204.545 177.384 204.507 177.315C204.469 177.245 204.445 177.169 204.437 177.09C204.428 177.011 204.435 176.931 204.458 176.855C204.48 176.779 204.517 176.708 204.567 176.647C204.616 176.585 204.678 176.533 204.747 176.495C204.817 176.457 204.893 176.433 204.972 176.425C208.175 175.706 211.429 175.235 214.704 175.014C214.865 175.005 215.023 175.059 215.144 175.165C215.266 175.271 215.34 175.421 215.353 175.582C215.36 175.662 215.35 175.742 215.325 175.819C215.3 175.895 215.259 175.966 215.206 176.026C215.154 176.087 215.089 176.136 215.017 176.171C214.944 176.206 214.866 176.226 214.785 176.23C211.564 176.439 208.364 176.9 205.215 177.609L205.102 177.625ZM234.298 176.49C231.476 176.295 228.118 176.084 224.566 176.019C224.405 176.015 224.253 175.948 224.141 175.833C224.028 175.718 223.966 175.564 223.966 175.403C223.966 175.323 223.982 175.244 224.013 175.17C224.044 175.096 224.09 175.029 224.147 174.973C224.205 174.917 224.273 174.873 224.347 174.844C224.422 174.815 224.502 174.801 224.582 174.803C228.167 174.884 231.557 175.079 234.314 175.273C234.394 175.277 234.473 175.298 234.545 175.333C234.618 175.368 234.682 175.417 234.735 175.478C234.788 175.538 234.829 175.609 234.854 175.685C234.879 175.761 234.888 175.842 234.882 175.922C234.894 176.069 234.853 176.214 234.766 176.333C234.68 176.452 234.554 176.537 234.411 176.571L234.298 176.49Z",
    fill: "#ECEFF1"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6599 275.74C94.5512 275.742 94.4439 275.714 94.3496 275.66C94.2553 275.606 94.1776 275.527 94.1247 275.432C93.3044 274.008 92.5731 272.534 91.935 271.02C91.9031 270.946 91.8863 270.867 91.8854 270.787C91.8845 270.708 91.8997 270.628 91.9299 270.554C91.9601 270.48 92.0048 270.413 92.0614 270.356C92.118 270.3 92.1853 270.255 92.2594 270.225C92.408 270.165 92.5741 270.166 92.7225 270.226C92.8709 270.287 92.9898 270.403 93.0541 270.549C93.6805 272.016 94.3899 273.446 95.179 274.832C95.2396 274.922 95.2738 275.027 95.2777 275.136C95.2816 275.245 95.2551 275.352 95.2011 275.447C95.1472 275.541 95.0679 275.618 94.9723 275.67C94.8767 275.722 94.7685 275.746 94.6599 275.74Z",
    fill: "#ECEFF1"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M291.652 403.943H230.081V416.562H291.652V403.943Z",
    fill: "white"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M291.652 403.943H230.081V416.562H291.652V403.943Z",
    fill: "black"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M256.017 403.943H230.081V416.562H256.017V403.943Z",
    fill: "black"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M230.081 405.76H284.888L230.081 407.317V405.76Z",
    fill: "black"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M291.652 407.949L244.143 409.133H291.652V407.949Z",
    fill: "black"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M232.595 411.485L256.016 410.528L290.452 411.485L256.016 412.02L232.595 411.485Z",
    fill: "black"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M230.081 414.161H270.663L230.081 415.118V414.161Z",
    fill: "black"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M291.554 415.118L264.451 415.621H291.652L291.554 415.118Z",
    fill: "black"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M283.088 391.324H221.517V403.943H283.088V391.324Z",
    fill: "white"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M283.088 391.324H221.517V403.943H283.088V391.324Z",
    fill: "black"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M247.452 391.324H221.517V403.943H247.452V391.324Z",
    fill: "black"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M221.517 393.14H276.324L221.517 394.681V393.14Z",
    fill: "black"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M283.088 395.33L235.579 396.514H283.088V395.33Z",
    fill: "black"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M224.014 398.866L247.436 397.893L281.871 398.866L247.436 399.401L224.014 398.866Z",
    fill: "black"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M221.517 401.526H262.099L221.517 402.499V401.526Z",
    fill: "black"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M282.99 402.499L255.887 403.002H283.088L282.99 402.499Z",
    fill: "black"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M290.111 378.688H228.54V391.307H290.111V378.688Z",
    fill: "white"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.111 378.688H228.54V391.307H290.111V378.688Z",
    fill: "black"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M254.476 378.688H228.54V391.307H254.476V378.688Z",
    fill: "black"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M228.54 380.505H283.347L228.54 382.062V380.505Z",
    fill: "black"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.111 382.695L242.603 383.879H290.111V382.695Z",
    fill: "black"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M231.054 386.231L254.476 385.274L288.911 386.231L254.476 386.766L231.054 386.231Z",
    fill: "black"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M228.54 388.907H269.122L228.54 389.864V388.907Z",
    fill: "black"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.03 389.864L262.926 390.367H290.111L290.03 389.864Z",
    fill: "black"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M331.131 416.303L332.721 410.252H398.509L428.792 413.286L429.944 416.303H331.131Z",
    fill: "#263238"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M398.509 410.252V416.303H331.131L332.721 410.252H398.509Z",
    fill: "black"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M385.29 381.3C385.378 382.033 385.308 382.777 385.085 383.481C384.861 384.185 384.49 384.834 383.995 385.382C383.5 385.931 382.893 386.367 382.216 386.662C381.538 386.956 380.806 387.102 380.067 387.09H279.308C277.733 387.056 276.224 386.449 275.063 385.384C273.901 384.318 273.168 382.867 272.999 381.3L267.014 316.793C266.949 316.163 266.993 315.526 267.143 314.911C267.423 313.778 268.079 312.774 269.005 312.064C269.93 311.354 271.07 310.979 272.236 311.002H373.06C374.636 311.036 376.145 311.643 377.306 312.709C378.467 313.774 379.201 315.226 379.37 316.793L385.29 381.3Z",
    fill: "#263238"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M379.71 387.09H279.308C277.733 387.056 276.224 386.449 275.063 385.384C273.901 384.318 273.168 382.866 272.999 381.3L267.014 316.793C266.949 316.163 266.993 315.526 267.143 314.911H367.545C369.121 314.945 370.63 315.552 371.791 316.618C372.952 317.683 373.686 319.135 373.855 320.702L379.84 385.209C379.905 385.839 379.861 386.475 379.71 387.09Z",
    fill: "black"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M310.483 347.53H331.326L325.779 407.203L358.738 412.15V416.302H289.316V412.15L303.541 407.203L310.483 347.53Z",
    fill: "#263238"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M331.326 347.53L315.884 415.362L303.541 414.989L310.483 347.53H331.326Z",
    fill: "white"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M331.229 676.488H321.302L303.444 427.916H316.631L331.229 676.488Z",
    fill: "#263238"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M331.245 676.488H321.302L304.32 440.276L303.444 428.322H316.631L317.344 440.276L331.245 676.488Z",
    fill: "white"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M317.344 439.676H304.32L303.444 428.322H316.631L317.344 439.676Z",
    fill: "black"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M404.154 676.488H394.227L392.605 427.916H405.776L404.154 676.488Z",
    fill: "#263238"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M405.792 428.322L405.532 468.434L404.17 676.488H394.227L392.865 468.434L392.605 428.322H405.792Z",
    fill: "white"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M405.792 428.322L405.532 468.872H392.865L392.605 428.322H405.792Z",
    fill: "black"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M509.649 676.488H499.722L481.864 427.916H495.051L509.649 676.488Z",
    fill: "#263238"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M509.665 676.488H499.722L482.74 440.276L481.864 428.322H495.051L495.764 440.276L509.665 676.488Z",
    fill: "white"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M495.764 439.676H482.74L481.864 428.322H495.051L495.764 439.676Z",
    fill: "black"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M217.559 676.488H207.632L222.23 427.916H235.417L217.559 676.488Z",
    fill: "#263238"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M235.417 428.322L234.541 440.276L217.559 676.488H207.632L221.517 440.276L222.23 428.322H235.417Z",
    fill: "white"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M222.23 428.322H235.417L234.541 439.676H221.517L222.23 428.322Z",
    fill: "black"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M211.785 421.72H505.496V430.657C505.496 431.117 505.406 431.573 505.23 431.998C505.053 432.423 504.796 432.809 504.47 433.135C504.145 433.46 503.759 433.718 503.333 433.894C502.908 434.07 502.453 434.161 501.993 434.161H215.288C214.359 434.161 213.468 433.792 212.811 433.135C212.154 432.478 211.785 431.586 211.785 430.657V421.72Z",
    fill: "#ECEFF1"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M211.785 421.72H505.496V430.657C505.496 431.117 505.406 431.573 505.23 431.998C505.053 432.423 504.796 432.809 504.47 433.135C504.145 433.46 503.759 433.718 503.333 433.894C502.908 434.07 502.453 434.161 501.993 434.161H215.288C214.359 434.161 213.468 433.792 212.811 433.135C212.154 432.478 211.785 431.586 211.785 430.657V421.72Z",
    fill: "white"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M505.496 421.704H211.785V427.932H505.496V421.704Z",
    fill: "black"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M511.66 423.342H205.621C204.692 423.342 203.801 422.973 203.144 422.316C202.487 421.659 202.117 420.768 202.117 419.838C202.117 418.908 202.486 418.015 203.143 417.355C203.799 416.696 204.69 416.323 205.621 416.319H511.66C512.591 416.323 513.482 416.696 514.138 417.355C514.795 418.015 515.163 418.908 515.163 419.838C515.163 420.768 514.794 421.659 514.137 422.316C513.48 422.973 512.589 423.342 511.66 423.342Z",
    fill: "#ECEFF1"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M511.66 423.342H205.621C204.692 423.342 203.801 422.973 203.144 422.316C202.487 421.659 202.117 420.768 202.117 419.838C202.117 418.908 202.486 418.015 203.143 417.355C203.799 416.696 204.69 416.323 205.621 416.319H511.66C512.591 416.323 513.482 416.696 514.138 417.355C514.795 418.015 515.163 418.908 515.163 419.838C515.163 420.768 514.794 421.659 514.137 422.316C513.48 422.973 512.589 423.342 511.66 423.342Z",
    fill: "white"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M439.254 405.5L443.017 399.855C443.388 399.301 443.89 398.847 444.478 398.532C445.067 398.218 445.724 398.054 446.391 398.055H451.159C451.555 398.056 451.949 398.116 452.327 398.233L469.342 403.391C470.309 403.68 471.132 404.323 471.645 405.192L474.094 409.295L439.254 405.5Z",
    fill: "#ECEFF1"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M474.094 409.295L449.294 406.603L439.221 405.5L442.984 399.855C443.355 399.301 443.857 398.847 444.446 398.532C445.034 398.218 445.691 398.054 446.358 398.055H451.127C451.528 398.057 451.927 398.117 452.311 398.233L452.684 398.347L469.31 403.391C470.282 403.678 471.11 404.321 471.629 405.192L474.094 409.295Z",
    fill: "black"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M474.094 409.295L449.294 406.603L452.684 398.347L469.309 403.391C470.282 403.678 471.11 404.321 471.629 405.192L474.094 409.295Z",
    fill: "black"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M485.87 415.767V416.302H433.285L435.231 408.695C435.592 407.298 436.408 406.061 437.551 405.179C438.694 404.298 440.098 403.823 441.541 403.829H464.865C465.641 403.825 466.41 403.963 467.136 404.235L470.056 405.321L481.637 409.636C482.887 410.099 483.964 410.936 484.721 412.033C485.479 413.13 485.88 414.434 485.87 415.767Z",
    fill: "#ECEFF1"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M485.87 415.767V416.302H464.281L465.433 408.079C465.507 407.569 465.694 407.082 465.981 406.654C466.268 406.226 466.646 405.867 467.09 405.604C467.533 405.341 468.029 405.181 468.542 405.135C469.056 405.089 469.573 405.158 470.056 405.338L481.637 409.652C482.884 410.114 483.959 410.949 484.717 412.043C485.474 413.137 485.876 414.437 485.87 415.767Z",
    fill: "black"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M467.639 410.723L474.516 390.107C474.583 389.897 474.695 389.704 474.845 389.542C474.995 389.38 475.178 389.253 475.382 389.169C475.586 389.086 475.806 389.048 476.026 389.059C476.247 389.069 476.462 389.128 476.657 389.231C476.956 389.403 477.193 389.665 477.333 389.98C477.473 390.295 477.509 390.646 477.436 390.983L471.645 412.977C471.645 412.977 467.801 414.534 467.639 410.723Z",
    fill: "#263238"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M439.254 414.599H436.204L436.788 411.599H439.838L439.254 414.599Z",
    fill: "black"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M443.795 414.486H440.746L441.33 411.485H444.379L443.795 414.486Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgcontactService);
export default __webpack_public_path__ + "static/media/Img.contact-service.e62fe40293709a86c497357fb85e262c.svg";
export { ForwardRef as ReactComponent };